(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4120],{

/***/ 6456:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...room]",
      function () {
        return __webpack_require__(2284);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ AutoChunkLoader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var AutoChunkLoader = function(param) {
    var error = param.error, retry = param.retry, timedOut = param.timedOut;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!error && !timedOut) return;
        var interval = setInterval(retry, 10000);
        return function() {
            clearInterval(interval);
        };
    }, [
        error,
        retry,
        timedOut
    ]);
    return null;
};


/***/ }),

/***/ 2709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ AutoChunkLoader/* AutoChunkLoader */.E; },
  "t": function() { return /* reexport */ ChunkLoader; }
});

// EXTERNAL MODULE: ./components/ChunkLoader/AutoChunkLoader.tsx
var AutoChunkLoader = __webpack_require__(2999);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(9547);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ../shared/dist/components/Button/index.js
var Button = __webpack_require__(9757);
// EXTERNAL MODULE: ../shared/dist/components/LoadingSpinner/index.js
var LoadingSpinner = __webpack_require__(3102);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(2031);
;// CONCATENATED MODULE: ./components/ChunkLoader/ChunkLoader.tsx






var ChunkLoader = function(param) {
    var className = param.className, error = param.error, retry = param.retry, _style = param.style, style = _style === void 0 ? {} : _style, timedOut = param.timedOut;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: style,
        className: "jsx-82d2dd96dd7dfca5" + " " + (classnames_default()("loader", className) || ""),
        children: [
            error || timedOut ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                variant: "ghost",
                onClick: retry,
                /*#__PURE__*/ children: t("general.retry")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner.LoadingSpinner, {}),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "82d2dd96dd7dfca5",
                children: ".loader.jsx-82d2dd96dd7dfca5{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ChunkLoader/index.ts




/***/ }),

/***/ 7532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* reexport */ PoweredByDailyBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(9547);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ../shared/dist/components/Anchor/index.js
var Anchor = __webpack_require__(757);
// EXTERNAL MODULE: ../shared/dist/components/Text/index.js
var Text = __webpack_require__(5645);
// EXTERNAL MODULE: ../shared/dist/contexts/Theme/index.js
var Theme = __webpack_require__(1609);
// EXTERNAL MODULE: ../shared/dist/hooks/useResize.js
var useResize = __webpack_require__(4605);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/PoweredByDailyBanner/PoweredByDailyBanner.tsx







var PoweredByDailyBanner = function() {
    var colors = (0,Theme.useTheme)().colors;
    var ref = (0,react.useState)(false), /*#__PURE__*/ isVisible = ref[0], setIsVisible = ref[1];
    var bannerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        setIsVisible(true);
        return function() {
            document.body.style.removeProperty("--banner-height");
        };
    }, []);
    (0,useResize.useResize)((0,react.useCallback)(function() {
        if (!bannerRef.current || !isVisible) return;
        document.body.style.setProperty("--banner-height", "".concat(bannerRef.current.clientHeight, "px"));
    }, [
        isVisible
    ]));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: bannerRef,
        className: styled_jsx_default().dynamic([
            [
                "14537fa28a63ead7",
                [
                    colors.system.greyDark
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text.Text, {
                color: "white",
                children: [
                    "Powered by",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor.Anchor, {
                        href: "https://daily.co",
                        underline: true,
                        children: "Daily"
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "14537fa28a63ead7",
                dynamic: [
                    colors.system.greyDark
                ],
                children: "div.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:".concat(colors.system.greyDark, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:6px 8px 8px;width:100%}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/PoweredByDailyBanner/index.ts



/***/ }),

/***/ 1967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mL": function() { return /* binding */ IframeDriverProvider; },
  "cK": function() { return /* binding */ useIframeDriver; }
});

// UNUSED EXPORTS: IframeDriverContext

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ../daily-react/dist/daily-react.esm.js + 1 modules
var daily_react_esm = __webpack_require__(4283);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./contexts/CallProvider.tsx + 1 modules
var CallProvider = __webpack_require__(6797);
// EXTERNAL MODULE: ./hooks/useCustomIntegrations.ts
var useCustomIntegrations = __webpack_require__(468);
// EXTERNAL MODULE: ./lib/participants.ts
var participants = __webpack_require__(1975);
// EXTERNAL MODULE: ./lib/state/custom.ts
var custom = __webpack_require__(3510);
// EXTERNAL MODULE: ./lib/state/layout.ts
var layout = __webpack_require__(7556);
// EXTERNAL MODULE: ./lib/userData.ts
var lib_userData = __webpack_require__(4218);
;// CONCATENATED MODULE: ./hooks/iframe/useIframeMeetingLifecycleHandlers.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var useIframeMeetingLifecycleHandlers = function(messageChannel) {
    var initializeCallArgs = (0,CallProvider/* useCallState */.oz)().initializeCallArgs;
    var ref11 = _slicedToArray((0,custom/* useShowFullscreenButton */.Ei)(), 2), setShowFullscreenButton = ref11[1];
    var ref1 = _slicedToArray((0,custom/* useShowLeaveButton */.Ik)(), 2), setShowLeaveButton = ref1[1];
    var ref2 = _slicedToArray((0,custom/* useShowLocalVideo */.sy)(), 2), setShowLocalVideo = ref2[1];
    var ref3 = _slicedToArray((0,custom/* useMaxGridTilesPerPage */.lW)(), 2), setMaxGridTilesPerPage = ref3[1];
    var ref4 = _slicedToArray((0,custom/* useMinGridTilesPerPage */.by)(), 2), setMinGridTilesPerPage = ref4[1];
    var ref5 = _slicedToArray((0,layout/* usePreferredViewMode */.Ut)(), 2), setPreferredViewMode = ref5[1];
    var ref6 = _slicedToArray((0,custom/* useCustomTrayButtons */.L_)(), 2), setCustomTrayButtons = ref6[1];
    var ref7 = _slicedToArray((0,custom/* useShowUserNameChangeUI */.te)(), 2), setShowUserNameChangeUI = ref7[1];
    var ref8 = _slicedToArray((0,custom/* useShowParticipantsBar */.Q1)(), 2), setShowParticipantsBar = ref8[1];
    var setCustomIntegrations = (0,useCustomIntegrations/* useCustomIntegrations */.J)().setCustomIntegrations;
    var handleDriverJoinMeetingMsg = (0,react.useCallback)(function(msg) {
        var ref, ref9, ref10;
        if (!msg.properties) return;
        var callArgs = _objectSpread({}, msg.properties);
        // It is okay to overwrite the settings in properties with the settings in the
        // preload cache because:
        // 1. If a new settings is provided in the join() call, the settings in preload cache and
        //    properties will be the same. Hence, this will essentially be a no-op.
        // 2. If no new settings are not provided in the join() call, the settings in preload cache
        //    will be the most upto date setting.
        if ((msg === null || msg === void 0 ? void 0 : (ref = msg.preloadCache) === null || ref === void 0 ? void 0 : ref.inputSettings) && // (empty object means uninitialized; would fail validation if used)
        Object.keys(msg.preloadCache.inputSettings).length) {
            callArgs.inputSettings = msg.preloadCache.inputSettings;
        }
        // != is on purpose because *DeviceId === false is valid
        if ((msg === null || msg === void 0 ? void 0 : (ref9 = msg.preloadCache) === null || ref9 === void 0 ? void 0 : ref9.audioDeviceId) != null) {
            callArgs.audioSource = msg.preloadCache.audioDeviceId;
        }
        if ((msg === null || msg === void 0 ? void 0 : (ref10 = msg.preloadCache) === null || ref10 === void 0 ? void 0 : ref10.videoDeviceId) != null) {
            callArgs.videoSource = msg.preloadCache.videoDeviceId;
        }
        if (callArgs.subscribeToTracksAutomatically !== undefined) {
            console.warn("Prebuilt UI does not support subscribeToTracksAutomatically option; ignoring");
            delete callArgs.subscribeToTracksAutomatically;
        }
        if (callArgs.layoutConfig) {
            if (callArgs.layoutConfig.grid) {
                if (Number.isInteger(callArgs.layoutConfig.grid.maxTilesPerPage)) {
                    setMaxGridTilesPerPage(callArgs.layoutConfig.grid.maxTilesPerPage);
                    delete callArgs.layoutConfig.grid.maxTilesPerPage;
                }
                if (Number.isInteger(callArgs.layoutConfig.grid.minTilesPerPage)) {
                    setMinGridTilesPerPage(callArgs.layoutConfig.grid.minTilesPerPage);
                    delete callArgs.layoutConfig.grid.minTilesPerPage;
                }
            }
        }
        if (callArgs.activeSpeakerMode !== undefined) {
            setPreferredViewMode(callArgs.activeSpeakerMode ? "speaker" : "grid");
            delete callArgs.activeSpeakerMode;
        }
        if (callArgs.customIntegrations !== undefined) {
            setCustomIntegrations(callArgs.customIntegrations);
            delete callArgs.customIntegrations;
        }
        if (callArgs.customTrayButtons !== undefined) {
            setCustomTrayButtons(callArgs.customTrayButtons);
            delete callArgs.customTrayButtons;
        }
        if (callArgs.showParticipantsBar !== undefined) {
            setShowParticipantsBar(callArgs.showParticipantsBar);
            delete callArgs.showParticipantsBar;
        }
        if (callArgs.showLocalVideo !== undefined) {
            setShowLocalVideo(callArgs.showLocalVideo);
            delete callArgs.showLocalVideo;
        }
        if (callArgs.showLeaveButton !== undefined) {
            setShowLeaveButton(callArgs.showLeaveButton);
            delete callArgs.showLeaveButton;
        }
        if (callArgs.showFullscreenButton !== undefined) {
            setShowFullscreenButton(callArgs.showFullscreenButton);
            delete callArgs.showFullscreenButton;
        }
        if (callArgs.userData !== undefined) {
            callArgs.userData = _defineProperty({}, lib_userData/* CUSTOMER_USER_DATA_KEY */.Ly, callArgs.userData);
        }
        if (callArgs.showUserNameChangeUI !== undefined) {
            setShowUserNameChangeUI(callArgs.showUserNameChangeUI);
            delete callArgs.showUserNameChangeUI;
        }
        initializeCallArgs(callArgs);
    // Swallow msg (don't forward to call machine): prebuilt UI knows to invoke
    // join() when appropriate. This avoids a multiple-join bug, and accounts
    // for actual join() occurring later in the prebuilt UI flow than when
    // the driver invokes it (i.e. when enable_prejoin_ui = true).
    }, [
        initializeCallArgs,
        setCustomIntegrations,
        setCustomTrayButtons,
        setMaxGridTilesPerPage,
        setMinGridTilesPerPage,
        setPreferredViewMode,
        setShowFullscreenButton,
        setShowLeaveButton,
        setShowLocalVideo,
        setShowParticipantsBar,
        setShowUserNameChangeUI, 
    ]);
    var handleCallMachineJoinedMeetingMsg = (0,react.useCallback)(function(msg) {
        // Remove tracks, which can't be serialized and sent through the
        // message channel.
        var newMsg = _objectSpread({}, msg);
        if (msg.participants) {
            newMsg.participants = (0,participants/* cloneParticipantsAndMungeForIframeProvider */._k)(newMsg.participants);
        }
        messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.forwardPackagedMessageToDriver(newMsg);
    }, [
        messageChannel
    ]);
    return {
        handleDriverJoinMeetingMsg: handleDriverJoinMeetingMsg,
        handleCallMachineJoinedMeetingMsg: handleCallMachineJoinedMeetingMsg
    };
};

;// CONCATENATED MODULE: ./hooks/iframe/useIframeParticipantsHandlers.ts
function useIframeParticipantsHandlers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useIframeParticipantsHandlers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useIframeParticipantsHandlers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var useIframeParticipantsHandlers = function(messageChannel) {
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var handleDriverUpdateParticipantMsg = (0,react.useCallback)(function(msg) {
        if (msg.properties && msg.properties["setSubscribedTracks"] !== undefined) {
            console.warn("Prebuilt UI does not support setSubscribedTracks in updateParticipant(); ignoring");
            delete msg.properties["setSubscribedTracks"];
        }
        // @ts-ignore
        daily === null || daily === void 0 ? void 0 : daily.forwardPackagedMessageToCallMachine(msg);
    }, [
        daily
    ]);
    var handleDriverUpdateParticipantsMsg = (0,react.useCallback)(function(msg) {
        if (msg.participants) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.values(msg.participants)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var participantUpdates = _step.value;
                    if (participantUpdates && participantUpdates["setSubscribedTracks"] !== undefined) {
                        console.warn("Prebuilt UI does not support setSubscribedTracks in updateParticipants(); ignoring");
                        delete participantUpdates["setSubscribedTracks"];
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        // @ts-ignore
        daily === null || daily === void 0 ? void 0 : daily.forwardPackagedMessageToCallMachine(msg);
    }, [
        daily
    ]);
    var handleDriverSetUserDataMsg = (0,react.useCallback)(function(msg) {
        var prebuiltUserData = (0,lib_userData/* getPrebuiltUserData */.n1)(daily);
        var userData = useIframeParticipantsHandlers_defineProperty({}, lib_userData/* CUSTOMER_USER_DATA_KEY */.Ly, msg.userData);
        // if both our data and iframe data is undefined, then setUserData to
        // undefined to take advantage of a slimmed down presence payload
        if (msg.userData === undefined && prebuiltUserData === undefined) {
            userData = undefined;
        } else if (prebuiltUserData !== undefined) {
            userData[lib_userData/* PREBUILT_USER_DATA_KEY */.Ui] = prebuiltUserData;
        }
        msg.userData = userData;
        // @ts-ignore
        daily === null || daily === void 0 ? void 0 : daily.forwardPackagedMessageToCallMachine(msg);
    }, [
        daily
    ]);
    var handleCallMachineParticipantMsg = (0,react.useCallback)(function(msg) {
        // Remove tracks, which can't be serialized and sent through the
        // message channel and clean up userData to only include iframe-set
        // data.
        var newMsg = useIframeParticipantsHandlers_objectSpread({}, msg);
        if (msg.participant) {
            newMsg.participant = (0,participants/* cloneParticipantAndMungeForIframeProvider */.$O)(msg.participant);
        }
        messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.forwardPackagedMessageToDriver(newMsg);
    }, [
        messageChannel
    ]);
    return {
        handleDriverUpdateParticipantMsg: handleDriverUpdateParticipantMsg,
        handleDriverUpdateParticipantsMsg: handleDriverUpdateParticipantsMsg,
        handleDriverSetUserDataMsg: handleDriverSetUserDataMsg,
        handleCallMachineParticipantMsg: handleCallMachineParticipantMsg
    };
};

// EXTERNAL MODULE: ../shared/dist/contexts/Theme/index.js
var Theme = __webpack_require__(1609);
// EXTERNAL MODULE: ./hooks/useCallConfig.ts
var useCallConfig = __webpack_require__(6081);
// EXTERNAL MODULE: ./lib/state/core.ts
var core = __webpack_require__(8890);
// EXTERNAL MODULE: ./lib/theme.ts
var lib_theme = __webpack_require__(6868);
;// CONCATENATED MODULE: ./hooks/iframe/useIframeCustomIntegrations.ts


var useIframeCustomIntegrations = function() {
    var ref1 = (0,useCustomIntegrations/* useCustomIntegrations */.J)(), setCustomIntegrations = ref1.setCustomIntegrations, startIntegration = ref1.startIntegration, stopIntegration = ref1.stopIntegration;
    var handleStartCustomIntegrationsMsg = (0,react.useCallback)(function(msg) {
        msg.ids.forEach(startIntegration);
    }, [
        startIntegration
    ]);
    var handleStopCustomIntegrationsMsg = (0,react.useCallback)(function(msg) {
        msg.ids.forEach(stopIntegration);
    }, [
        stopIntegration
    ]);
    /**
   * When the client calls `setCustomIntegrations` this function is executed.
   */ var handleSetCustomIntegrationsMsg = (0,react.useCallback)(function(msg) {
        var ref;
        var newIntegrations = (ref = msg === null || msg === void 0 ? void 0 : msg.integrations) !== null && ref !== void 0 ? ref : {};
        setCustomIntegrations(newIntegrations);
    }, [
        setCustomIntegrations
    ]);
    return {
        handleSetCustomIntegrationsMsg: handleSetCustomIntegrationsMsg,
        handleStartCustomIntegrationsMsg: handleStartCustomIntegrationsMsg,
        handleStopCustomIntegrationsMsg: handleStopCustomIntegrationsMsg
    };
};

;// CONCATENATED MODULE: ./hooks/iframe/useIframeUIControlHandlers.ts
function useIframeUIControlHandlers_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useIframeUIControlHandlers_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return useIframeUIControlHandlers_arrayLikeToArray(arr);
}
function useIframeUIControlHandlers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useIframeUIControlHandlers_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useIframeUIControlHandlers_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useIframeUIControlHandlers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useIframeUIControlHandlers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useIframeUIControlHandlers_slicedToArray(arr, i) {
    return useIframeUIControlHandlers_arrayWithHoles(arr) || useIframeUIControlHandlers_iterableToArrayLimit(arr, i) || useIframeUIControlHandlers_unsupportedIterableToArray(arr, i) || useIframeUIControlHandlers_nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || useIframeUIControlHandlers_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function useIframeUIControlHandlers_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useIframeUIControlHandlers_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useIframeUIControlHandlers_arrayLikeToArray(o, minLen);
}










var useIframeUIControlHandlers = function(messageChannel) {
    var ref12 = useIframeUIControlHandlers_slicedToArray((0,custom/* useCustomTrayButtons */.L_)(), 2), setCustomTrayButtons = ref12[1];
    var ref1 = useIframeUIControlHandlers_slicedToArray((0,custom/* useEnableJoinSound */.Xn)(), 2), setEnableJoinSound = ref1[1];
    var ref2 = useIframeUIControlHandlers_slicedToArray((0,custom/* useIsFullscreen */.hb)(), 2), setIsFullscreen = ref2[1];
    var ref3 = useIframeUIControlHandlers_slicedToArray((0,custom/* useShowLocalVideo */.sy)(), 2), showLocalVideo = ref3[0], setShowLocalVideo = ref3[1];
    var ref4 = useIframeUIControlHandlers_slicedToArray((0,custom/* useShowNames */.zD)(), 2), setShowNames = ref4[1];
    var ref5 = useIframeUIControlHandlers_slicedToArray((0,custom/* useShowParticipantsBar */.Q1)(), 2), setShowParticipantsBar = ref5[1];
    var ref6 = useIframeUIControlHandlers_slicedToArray((0,core/* useSidebarView */.oS)(), 2), sidebarView1 = ref6[0], setSidebarView = ref6[1];
    var ref7 = (0,Theme.useTheme)(), setDarkColors = ref7.setDarkColors, setLightColors = ref7.setLightColors;
    var ref8 = useIframeUIControlHandlers_slicedToArray((0,layout/* usePreferredViewMode */.Ut)(), 2), preferredViewMode = ref8[0], setPreferredViewMode = ref8[1];
    var ref9 = (0,react.useState)(false), activeSpeakerMode = ref9[0], setActiveSpeakerMode = ref9[1];
    var ref10 = (0,useCallConfig/* useCallConfig */.A)(), enableBreakoutRooms = ref10.enableBreakoutRooms, enableChat = ref10.enableChat, enableNetworkUI = ref10.enableNetworkUI, enablePeopleUI = ref10.enablePeopleUI;
    var sidebarIntegrations = (0,useCustomIntegrations/* useCustomIntegrations */.J)().sidebarIntegrations;
    var handleDriverSetActiveSpeakerModeMsg = (0,react.useCallback)(function(msg) {
        // Map activeSpeakerMode to preferredViewMode
        setPreferredViewMode(msg.enabled ? "speaker" : "grid");
    // Swallow msg (don't forward to call machine)
    }, [
        setPreferredViewMode
    ]);
    var handleDriverShowLocalVideoMsg = (0,react.useCallback)(function(msg) {
        // Map showLocalVideo (property) to showLocalVideo (state)
        setShowLocalVideo(msg === null || msg === void 0 ? void 0 : msg.show);
    // Swallow msg (don't forward to call machine)
    }, [
        setShowLocalVideo
    ]);
    var handleDriverShowParticipantsBarMsg = (0,react.useCallback)(function(msg) {
        // Map showParticipantsBar (property) to showParticipantsBar (state)
        setShowParticipantsBar(msg === null || msg === void 0 ? void 0 : msg.show);
    // Swallow msg (don't forward to call machine)
    }, [
        setShowParticipantsBar
    ]);
    var ref11 = useIframeCustomIntegrations(), handleSetCustomIntegrationsMsg = ref11.handleSetCustomIntegrationsMsg, handleStartCustomIntegrationsMsg = ref11.handleStartCustomIntegrationsMsg, handleStopCustomIntegrationsMsg = ref11.handleStopCustomIntegrationsMsg;
    var handleUpdateCustomTrayButtonsMsg = (0,react.useCallback)(function(msg) {
        setCustomTrayButtons(msg === null || msg === void 0 ? void 0 : msg.btns);
    }, [
        setCustomTrayButtons
    ]);
    var isOwner = (0,daily_react_esm/* useParticipantProperty */.ou)((0,daily_react_esm/* useLocalSessionId */.q5)(), "owner");
    var availableSidebarViews = (0,react.useMemo)(function() {
        var availableViews = [
            null, 
        ].concat(_toConsumableArray(sidebarIntegrations.map(function(i) {
            return i.id;
        })));
        if (enablePeopleUI) availableViews.push("people");
        if (enableChat) availableViews.push("chat");
        if (enableNetworkUI) availableViews.push("network");
        if (enableBreakoutRooms && isOwner) availableViews.push("breakout");
        return availableViews;
    }, [
        enableBreakoutRooms,
        enableChat,
        enableNetworkUI,
        enablePeopleUI,
        isOwner,
        sidebarIntegrations, 
    ]);
    var handleGetSidebarViewMsg = (0,react.useCallback)(function(msg) {
        messageChannel.sendMessageToDriver(useIframeUIControlHandlers_objectSpread({}, msg, {
            action: "get-sidebar-view",
            view: sidebarView1
        }));
    }, [
        messageChannel,
        sidebarView1
    ]);
    var handleSetSidebarViewMsg = (0,react.useCallback)(function(msg) {
        var sidebarView = msg === null || msg === void 0 ? void 0 : msg.view;
        if (availableSidebarViews.includes(sidebarView)) {
            setSidebarView(sidebarView);
        } else {
            console.warn('No sidebar view "'.concat(sidebarView, '" available. Ignoring.'));
        }
    }, [
        availableSidebarViews,
        setSidebarView
    ]);
    var handleSetThemeMsg = (0,react.useCallback)(function(msg) {
        var theme = msg === null || msg === void 0 ? void 0 : msg.theme;
        if (!theme) return;
        var ref = useIframeUIControlHandlers_slicedToArray((0,lib_theme/* convertDailyThemeColors */.Bi)(theme), 2), light = ref[0], dark = ref[1];
        setLightColors(light);
        setDarkColors(dark);
    }, [
        setDarkColors,
        setLightColors
    ]);
    var handleDriverShowNames = (0,react.useCallback)(function(msg) {
        // Map showNamesMode to showNames
        setShowNames((msg === null || msg === void 0 ? void 0 : msg.mode) !== "never");
    // Swallow msg (don't forward to call machine)
    }, [
        setShowNames
    ]);
    var handleDriverEnterFullscreen = (0,react.useCallback)(function(_msg) {
        // Map fullscreen to isFullscreen
        setIsFullscreen(true);
    // Swallow msg (don't forward to call machine)
    }, [
        setIsFullscreen
    ]);
    var handleDriverExitFullscreen = (0,react.useCallback)(function(_msg) {
        // Map exited-fullscreen to isFullscreen
        setIsFullscreen(false);
    // Swallow msg (don't forward to call machine)
    }, [
        setIsFullscreen
    ]);
    var handleDriverSetPlayNewParticipantSound = (0,react.useCallback)(function(msg) {
        setEnableJoinSound(msg.arg);
    }, [
        setEnableJoinSound
    ]);
    /**
   * Map preferredViewMode to activeSpeakerMode (used by API).
   */ (0,react.useEffect)(function() {
        setActiveSpeakerMode(preferredViewMode === "speaker");
    }, [
        preferredViewMode
    ]);
    /**
   * Fire show-local-video-changed event when showLocalVideo changes.
   */ (0,react.useEffect)(function() {
        messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.sendMessageToDriver({
            action: "show-local-video-changed",
            show: showLocalVideo
        });
    }, [
        messageChannel,
        showLocalVideo
    ]);
    /**
   * Fire set-active-speaker-mode event when activeSpeakerMode changes.
   */ (0,react.useEffect)(function() {
        messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.sendMessageToDriver({
            action: "active-speaker-mode-change",
            enabled: activeSpeakerMode
        });
    }, [
        activeSpeakerMode,
        messageChannel
    ]);
    /**
   * Fire sidebar-view-changed event when sidebarView changes.
   */ (0,react.useEffect)(function() {
        messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.sendMessageToDriver({
            action: "sidebar-view-changed",
            view: sidebarView1
        });
    }, [
        sidebarView1,
        messageChannel
    ]);
    return {
        handleDriverEnterFullscreen: handleDriverEnterFullscreen,
        handleDriverExitFullscreen: handleDriverExitFullscreen,
        handleDriverSetActiveSpeakerModeMsg: handleDriverSetActiveSpeakerModeMsg,
        handleDriverSetPlayNewParticipantSound: handleDriverSetPlayNewParticipantSound,
        handleDriverShowLocalVideoMsg: handleDriverShowLocalVideoMsg,
        handleDriverShowNames: handleDriverShowNames,
        handleDriverShowParticipantsBarMsg: handleDriverShowParticipantsBarMsg,
        handleGetSidebarViewMsg: handleGetSidebarViewMsg,
        handleSetCustomIntegrationsMsg: handleSetCustomIntegrationsMsg,
        handleSetSidebarViewMsg: handleSetSidebarViewMsg,
        handleSetThemeMsg: handleSetThemeMsg,
        handleStartCustomIntegrationsMsg: handleStartCustomIntegrationsMsg,
        handleStopCustomIntegrationsMsg: handleStopCustomIntegrationsMsg,
        handleUpdateCustomTrayButtonsMsg: handleUpdateCustomTrayButtonsMsg
    };
};

;// CONCATENATED MODULE: ./contexts/IframeDriverMessageChannel.ts
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function IframeDriverMessageChannel_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function IframeDriverMessageChannel_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            IframeDriverMessageChannel_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var IframeDriverMessageChannel = /*#__PURE__*/ function() {
    "use strict";
    function IframeDriverMessageChannel(frameId) {
        _classCallCheck(this, IframeDriverMessageChannel);
        this._wrappedListeners = {};
        this._incrementingListenerId = 0;
        this._frameId = frameId;
    }
    var _proto = IframeDriverMessageChannel.prototype;
    _proto.addListenerForMessagesFromDriver = function addListenerForMessagesFromDriver(listener) {
        var _this = this;
        var wrappedListener = function(evt) {
            var ref, ref1, ref2, ref3;
            var isIframeCallMessage = (evt === null || evt === void 0 ? void 0 : (ref = evt.data) === null || ref === void 0 ? void 0 : ref.what) === "iframe-call-message";
            var hasAction = evt === null || evt === void 0 ? void 0 : (ref1 = evt.data) === null || ref1 === void 0 ? void 0 : ref1.action;
            var isFromModule = !(evt === null || evt === void 0 ? void 0 : (ref2 = evt.data) === null || ref2 === void 0 ? void 0 : ref2.from) || evt.data.from === "module";
            var isTargetFrame = (evt === null || evt === void 0 ? void 0 : (ref3 = evt.data) === null || ref3 === void 0 ? void 0 : ref3.callFrameId) && _this._frameId ? evt.data.callFrameId === _this._frameId : true;
            if (!(isIframeCallMessage && hasAction && isFromModule && isTargetFrame)) {
                return;
            }
            var msg = evt.data;
            listener(msg);
        };
        this._wrappedListeners[this._incrementingListenerId] = wrappedListener;
        window.addEventListener("message", wrappedListener);
        return this._incrementingListenerId++;
    };
    _proto.removeListenerForMessagesFromDriver = function removeListenerForMessagesFromDriver(listenerId) {
        var wrappedListener = this._wrappedListeners[listenerId];
        if (wrappedListener) {
            window.removeEventListener("message", wrappedListener);
            delete this._wrappedListeners[listenerId];
        }
    };
    _proto.sendMessageToDriver = function sendMessageToDriver(message) {
        var ref;
        message.what = "iframe-call-message";
        message.callFrameId = this._frameId;
        message.from = "embedded";
        (ref = window.parent) === null || ref === void 0 ? void 0 : ref.postMessage(message, "*");
    };
    _proto.forwardPackagedMessageToDriver = function forwardPackagedMessageToDriver(msg) {
        var ref;
        var newMsg = IframeDriverMessageChannel_objectSpread({}, msg);
        newMsg.callFrameId = this._frameId;
        (ref = window.parent) === null || ref === void 0 ? void 0 : ref.postMessage(newMsg, "*");
    };
    return IframeDriverMessageChannel;
}();
/**
 * A message channel to and from a driver controlling the call UI via an iframe
 * (e.g. daily-js).
 * Based on WebMessageChannel in pluot-core.
 */ 

;// CONCATENATED MODULE: ./contexts/IframeDriverProvider.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function IframeDriverProvider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function IframeDriverProvider_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            IframeDriverProvider_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var IframeDriverContext = /*#__PURE__*/ (0,react.createContext)(null);
var IframeDriverProvider = function(param) {
    var children = param.children, frameId = param.frameId;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var ref = (0,react.useState)(null), messageChannel = ref[0], setMessageChannel = ref[1];
    var ref1 = useIframeMeetingLifecycleHandlers(messageChannel), handleCallMachineJoinedMeetingMsg = ref1.handleCallMachineJoinedMeetingMsg, handleDriverJoinMeetingMsg = ref1.handleDriverJoinMeetingMsg;
    var ref2 = useIframeParticipantsHandlers(messageChannel), handleCallMachineParticipantMsg = ref2.handleCallMachineParticipantMsg, handleDriverSetUserDataMsg = ref2.handleDriverSetUserDataMsg, handleDriverUpdateParticipantMsg = ref2.handleDriverUpdateParticipantMsg, handleDriverUpdateParticipantsMsg = ref2.handleDriverUpdateParticipantsMsg;
    var ref3 = useIframeUIControlHandlers(messageChannel), handleDriverEnterFullscreen = ref3.handleDriverEnterFullscreen, handleDriverExitFullscreen = ref3.handleDriverExitFullscreen, handleDriverSetActiveSpeakerModeMsg = ref3.handleDriverSetActiveSpeakerModeMsg, handleDriverSetPlayNewParticipantSound = ref3.handleDriverSetPlayNewParticipantSound, handleDriverShowLocalVideoMsg = ref3.handleDriverShowLocalVideoMsg, handleDriverShowNames = ref3.handleDriverShowNames, handleDriverShowParticipantsBarMsg = ref3.handleDriverShowParticipantsBarMsg, handleGetSidebarViewMsg = ref3.handleGetSidebarViewMsg, handleSetCustomIntegrationsMsg = ref3.handleSetCustomIntegrationsMsg, handleSetSidebarViewMsg = ref3.handleSetSidebarViewMsg, handleSetThemeMsg = ref3.handleSetThemeMsg, handleStartCustomIntegrationsMsg = ref3.handleStartCustomIntegrationsMsg, handleStopCustomIntegrationsMsg = ref3.handleStopCustomIntegrationsMsg, handleUpdateCustomTrayButtonsMsg = ref3.handleUpdateCustomTrayButtonsMsg;
    /**
   * Create a message channel to the iframe driver, if we're in an iframe.
   */ (0,react.useEffect)(function() {
        if (!frameId) return;
        setMessageChannel(new IframeDriverMessageChannel(frameId));
        return function() {
            setMessageChannel(null);
        };
    }, [
        frameId
    ]);
    /**
   * Tell the driver that the prebuilt UI has loaded, unblocking it from sending
   * subsequent messages like 'join-meeting'.
   */ (0,react.useEffect)(function() {
        if (!messageChannel) return;
        messageChannel.sendMessageToDriver({
            action: "loaded"
        });
    }, [
        messageChannel
    ]);
    var handleEnumerateDevices = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(_msg) {
            var jRT, raw, devices;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        jRT = function(struct) {
                            try {
                                return JSON.parse(JSON.stringify(struct));
                            } catch (e) {
                                return null;
                            }
                        };
                        _ctx.next = 3;
                        return navigator.mediaDevices.enumerateDevices();
                    case 3:
                        raw = _ctx.sent;
                        devices = raw.map(jRT);
                        messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.sendMessageToDriver(IframeDriverProvider_objectSpread({}, _msg, {
                            devices: devices
                        }));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_msg) {
            return _ref.apply(this, arguments);
        };
    }(), [
        messageChannel
    ]);
    /**
   * Set up handling of messages from the iframe driver.
   *
   * Note that we don't require callObject to exist yet in this effect, since
   * 'join-meeting' can happen *before* we initialize our callObject.
   */ (0,react.useEffect)(function() {
        if (!messageChannel) return;
        var driverListenerId = messageChannel.addListenerForMessagesFromDriver(function(msg) {
            switch(msg.action){
                // Add any special-case message handling here. Special messages include:
                // - UI control messages (e.g. 'set-active-speaker-mode')
                // - call machine control messages that require non-default handling
                // Note: try not to modify the message, to not interfere with possible
                // other listeners in the chain.
                case "set-custom-integrations":
                    handleSetCustomIntegrationsMsg(msg);
                    break;
                case "start-custom-integrations":
                    handleStartCustomIntegrationsMsg(msg);
                    break;
                case "stop-custom-integrations":
                    handleStopCustomIntegrationsMsg(msg);
                    break;
                case "update-custom-tray-buttons":
                    handleUpdateCustomTrayButtonsMsg(msg);
                    break;
                case "get-sidebar-view":
                    handleGetSidebarViewMsg(msg);
                    break;
                case "set-sidebar-view":
                    handleSetSidebarViewMsg(msg);
                    break;
                case "set-theme":
                    handleSetThemeMsg(msg);
                    break;
                case "join-meeting":
                    handleDriverJoinMeetingMsg(msg);
                    break;
                case "daily-method-set-play-ding":
                    handleDriverSetPlayNewParticipantSound(msg);
                    break;
                case "daily-method-subscribe-to-tracks-automatically":
                    console.warn("Prebuilt UI does not support setSubscribeToTracksAutomatically()");
                    break;
                case "update-participant":
                    handleDriverUpdateParticipantMsg(msg);
                    break;
                case "update-participants":
                    handleDriverUpdateParticipantsMsg(msg);
                    break;
                case "set-user-data":
                    handleDriverSetUserDataMsg(msg);
                    break;
                case "set-active-speaker-mode":
                    handleDriverSetActiveSpeakerModeMsg(msg);
                    break;
                case "set-show-local-video":
                    handleDriverShowLocalVideoMsg(msg);
                    break;
                case "set-show-names":
                    handleDriverShowNames(msg);
                    break;
                case "set-show-participants-bar":
                    handleDriverShowParticipantsBarMsg(msg);
                    break;
                case "fullscreen":
                    handleDriverEnterFullscreen(msg);
                    break;
                case "exited-fullscreen":
                    handleDriverExitFullscreen(msg);
                    break;
                case "enumerate-devices":
                    handleEnumerateDevices(msg);
                    break;
                default:
                    // By default, simply pass along the message to the call machine.
                    // (Right now we're using a special "private" callObject method, for
                    //  convenience. Note that it doesn't have to be this way: if we
                    //  wanted to limit ourselves only to public callObject methods, we
                    //  could handle each message from the driver as a special case,
                    //  invoking the corresponding callObject method and forwarding the
                    //  response to the iframe driver.)
                    // @ts-ignore
                    daily === null || daily === void 0 ? void 0 : daily.forwardPackagedMessageToCallMachine(msg);
                    break;
            }
        });
        return function() {
            messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.removeListenerForMessagesFromDriver(driverListenerId);
        };
    }, [
        daily,
        handleDriverEnterFullscreen,
        handleDriverExitFullscreen,
        handleDriverJoinMeetingMsg,
        handleDriverSetActiveSpeakerModeMsg,
        handleDriverSetPlayNewParticipantSound,
        handleDriverSetUserDataMsg,
        handleDriverShowLocalVideoMsg,
        handleDriverShowNames,
        handleDriverShowParticipantsBarMsg,
        handleDriverUpdateParticipantMsg,
        handleDriverUpdateParticipantsMsg,
        handleEnumerateDevices,
        handleGetSidebarViewMsg,
        handleSetCustomIntegrationsMsg,
        handleSetSidebarViewMsg,
        handleSetThemeMsg,
        handleStartCustomIntegrationsMsg,
        handleStopCustomIntegrationsMsg,
        handleUpdateCustomTrayButtonsMsg,
        messageChannel, 
    ]);
    /**
   * Set up handling of messages from the call machine.
   */ (0,react.useEffect)(function() {
        if (!daily) return;
        // Listen for any messages from the call machine.
        // (Right now we're using a special "private" callObject method, for
        //  convenience. Note that it doesn't have to be this way: see comment in
        //  driver message listener for a description of the public-method-only
        //  approach.)
        var callMachineListenerId = // @ts-ignore
        daily.addListenerForPackagedMessagesFromCallMachine(function(msg) {
            switch(msg.action){
                // Add any special-case message handling here.
                // Note: try not to modify the message, to not interfere with possible
                // other listeners in the chain.
                case "loaded":
                    break;
                case "joined-meeting":
                    handleCallMachineJoinedMeetingMsg(msg);
                    break;
                case "participant-joined":
                case "participant-updated":
                case "participant-left":
                    handleCallMachineParticipantMsg(msg);
                    break;
                case "track-started":
                case "track-stopped":
                    break;
                default:
                    // By default, simply pass along the message to the iframe driver.
                    messageChannel === null || messageChannel === void 0 ? void 0 : messageChannel.forwardPackagedMessageToDriver(msg);
                    break;
            }
        });
        return function() {
            // @ts-ignore
            daily.removeListenerForPackagedMessagesFromCallMachine(callMachineListenerId);
        };
    }, [
        daily,
        messageChannel,
        handleCallMachineJoinedMeetingMsg,
        handleCallMachineParticipantMsg, 
    ]);
    var sendMessageToDriver = (0,react.useCallback)(function(message) {
        if (!messageChannel) return;
        messageChannel.sendMessageToDriver(message);
    }, [
        messageChannel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IframeDriverContext.Provider, {
        value: {
            sendMessageToDriver: sendMessageToDriver
        },
        children: children
    });
};
var useIframeDriver = function() {
    return (0,react.useContext)(IframeDriverContext);
};


/***/ }),

/***/ 269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ MediaDeviceProvider; },
/* harmony export */   "w": function() { return /* binding */ useMediaDevices; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4283);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _lib_browserConfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7530);
/* harmony import */ var _lib_state_modals__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5328);
/* harmony import */ var _CallProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6797);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var noop = function() {};
var REREQUEST_INTERVAL = 2000;
var MediaDeviceContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createContext)({
    promptForAccess: noop
});
var MediaDeviceProvider = function(param) {
    var children = param.children;
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useDaily */ .VI)();
    var ref5 = (0,_CallProvider__WEBPACK_IMPORTED_MODULE_6__/* .useCallState */ .oz)(), disableAudio = ref5.disableAudio, mode = ref5.mode, state = ref5.state;
    var room = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useRoom */ .NW)();
    var ref1 = _slicedToArray((0,_lib_state_modals__WEBPACK_IMPORTED_MODULE_5__/* .useDeviceInUseModal */ .IA)(), 2), setShowDeviceInUseModal = ref1[1];
    var ref2 = _slicedToArray((0,_lib_state_modals__WEBPACK_IMPORTED_MODULE_5__/* .useDeviceNotFoundModal */ .YH)(), 2), setShowDeviceNotFoundModal = ref2[1];
    var ref3 = _slicedToArray((0,_lib_state_modals__WEBPACK_IMPORTED_MODULE_5__/* .useUnblockPermissionsModal */ .OB)(), 2), showUnblockPermissionsModal = ref3[0], setShowUnblockPermissionsModal = ref3[1];
    var ref4 = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useDevices */ .Ls)(), camState = ref4.camState, micState = ref4.micState;
    /**
     * Clean up modals, when errors are resolved.
     */ (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (camState !== "blocked" && micState !== "blocked") {
            setShowUnblockPermissionsModal(false);
        }
        if (camState !== "in-use" && micState !== "in-use") {
            setShowDeviceInUseModal(false);
        }
        if (camState !== "not-found" && micState !== "not-found") {
            setShowDeviceNotFoundModal(false);
        }
    }, [
        camState,
        micState,
        setShowDeviceInUseModal,
        setShowDeviceNotFoundModal,
        setShowUnblockPermissionsModal, 
    ]);
    /**
     * Automatically show modal when selected device is in use.
     */ (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (state !== "joined" || camState !== "in-use") return;
        setShowDeviceInUseModal(true);
    }, [
        camState,
        setShowDeviceInUseModal,
        state
    ]);
    var promptForAccess = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        if ((0,_lib_browserConfig__WEBPACK_IMPORTED_MODULE_4__/* .isSafari */ .G6)() || (0,_lib_browserConfig__WEBPACK_IMPORTED_MODULE_4__/* .isIOSMobile */ .eS)()) {
            if (mode === "direct-link") {
                if (showUnblockPermissionsModal) {
                    window.location.reload();
                } else {
                    setShowUnblockPermissionsModal(true);
                }
            } else {
                if (!(0,_lib_browserConfig__WEBPACK_IMPORTED_MODULE_4__/* .isIOSMobile */ .eS)() || (0,_lib_browserConfig__WEBPACK_IMPORTED_MODULE_4__/* .isSafari */ .G6)(14)) {
                    var openModal = true;
                    var openTimeout = setTimeout(function() {
                        openModal = false;
                    }, 1500);
                    daily.once("camera-error", function() {
                        if (openModal) {
                            setShowUnblockPermissionsModal(true);
                            clearTimeout(openTimeout);
                        }
                    });
                }
                daily.setLocalVideo(true);
                if (!disableAudio) daily.setLocalAudio(true);
            }
        } else {
            setShowUnblockPermissionsModal(true);
        }
    }, [
        daily,
        disableAudio,
        mode,
        setShowUnblockPermissionsModal,
        showUnblockPermissionsModal, 
    ]);
    var browser = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return bowser__WEBPACK_IMPORTED_MODULE_2___default().parse(navigator.userAgent);
    }, []);
    /**
     * Automatically re-request cam access.
     */ (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (!daily || !room) return;
        var interval;
        switch(camState){
            case "in-use":
                var ref;
                if ((browser === null || browser === void 0 ? void 0 : (ref = browser.browser) === null || ref === void 0 ? void 0 : ref.name) === "Firefox") return;
            case "blocked":
                if ((0,_lib_browserConfig__WEBPACK_IMPORTED_MODULE_4__/* .isSafari */ .G6)() || (0,_lib_browserConfig__WEBPACK_IMPORTED_MODULE_4__/* .isIOSMobile */ .eS)()) return;
                interval = setInterval(function() {
                    try {
                        daily.setLocalVideo(true);
                    } catch (e) {}
                }, REREQUEST_INTERVAL);
                break;
            default:
                break;
        }
        return function() {
            clearInterval(interval);
        };
    }, [
        browser,
        camState,
        daily,
        room
    ]);
    /**
     * Automatically try to restore mic access, but only after cam access has
     * been unblocked (the mic access request piggybacks on the cam one).
     */ (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (!daily || !room) return;
        var interval;
        switch(micState){
            case "in-use":
                var ref6;
                if ((browser === null || browser === void 0 ? void 0 : (ref6 = browser.browser) === null || ref6 === void 0 ? void 0 : ref6.name) === "Firefox") return;
            case "blocked":
                if ((0,_lib_browserConfig__WEBPACK_IMPORTED_MODULE_4__/* .isSafari */ .G6)() || (0,_lib_browserConfig__WEBPACK_IMPORTED_MODULE_4__/* .isIOSMobile */ .eS)()) return;
                // cam's still blocked; let's wait for it to get unblocked before
                // trying to restore mic access
                if (camState === "blocked" || camState === "in-use") {
                    return;
                }
                interval = setInterval(function() {
                    try {
                        // cam's unblocked, so try to restore mic access now
                        if (!disableAudio) {
                            var ref;
                            daily.setLocalAudio(true);
                            if (room === null || room === void 0 ? void 0 : (ref = room.config) === null || ref === void 0 ? void 0 : ref.start_audio_off) {
                                daily.setLocalAudio(false);
                            }
                        }
                    } catch (e) {}
                }, REREQUEST_INTERVAL);
                break;
            default:
                break;
        }
        return function() {
            clearInterval(interval);
        };
    }, [
        browser,
        camState,
        micState,
        daily,
        disableAudio,
        room
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaDeviceContext.Provider, {
        value: {
            promptForAccess: promptForAccess
        },
        children: children
    });
};
var useMediaDevices = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(MediaDeviceContext);
};


/***/ }),

/***/ 9394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": function() { return /* binding */ useParticipants; },
/* harmony export */   "EF": function() { return /* binding */ useCurrentSpeakerId; },
/* harmony export */   "Q": function() { return /* binding */ useParticipantMetaData; },
/* harmony export */   "Ub": function() { return /* binding */ useMuteNewParticipants; },
/* harmony export */   "jU": function() { return /* binding */ useParticipantMarkedForRemoval; },
/* harmony export */   "n5": function() { return /* binding */ ParticipantsProvider; },
/* harmony export */   "o8": function() { return /* binding */ useOrderedParticipantIds; }
/* harmony export */ });
/* unused harmony export ParticipantsContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4283);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4480);
/* harmony import */ var _features_breakouts_hooks_useBreakoutSessionState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1925);
/* harmony import */ var _hooks_useCallConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6081);
/* harmony import */ var _hooks_usePreviousValue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3584);
/* harmony import */ var _lib_participants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1975);
/* harmony import */ var _lib_state_layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7556);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









var ParticipantsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)(null);
var participantMetaDataState = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .atom */ .cn)({
    key: "participant-meta-data",
    default: {}
});
var useParticipantMetaData = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(participantMetaDataState);
};
var orderedParticipantIdsState = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .atom */ .cn)({
    key: "ordered-participant-ids",
    default: []
});
var useOrderedParticipantIds = function() {
    var orderedIds = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(orderedParticipantIdsState);
    var ref = (0,_features_breakouts_hooks_useBreakoutSessionState__WEBPACK_IMPORTED_MODULE_4__/* .useBreakoutSessionState */ .V)(), breakoutParticipantIds = ref.breakoutParticipantIds, hasJoinedBreakout = ref.hasJoinedBreakout, mainRoomParticipantIds = ref.mainRoomParticipantIds;
    return orderedIds.filter(function(id) {
        return hasJoinedBreakout ? breakoutParticipantIds.includes(id) : mainRoomParticipantIds.includes(id);
    });
};
var participantMarkedForRemovalState = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .atom */ .cn)({
    key: "participant-marked-for-removal",
    default: ""
});
var useParticipantMarkedForRemoval = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilState */ .FV)(participantMarkedForRemovalState);
};
var muteNewParticipantsState = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .atom */ .cn)({
    key: "mute-new-participants",
    default: false
});
var useMuteNewParticipants = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(muteNewParticipantsState);
};
var ParticipantsEventsHandler = function() {
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useDaily */ .VI)();
    var broadcast = (0,_hooks_useCallConfig__WEBPACK_IMPORTED_MODULE_5__/* .useCallConfig */ .A)().broadcast;
    var muteNewParticipants = useMuteNewParticipants();
    /**
   * Maintain positions for each participant in Speaker & Grid view.
   */ (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useThrottledDailyEvent */ .CH)([
        "participant-joined",
        "participant-left"
    ], (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilCallback */ ._8)(function(param1) {
        var transact_UNSTABLE = param1.transact_UNSTABLE;
        return function(evts) {
            var ref2;
            var ref1;
            var participants = (ref1 = daily === null || daily === void 0 ? void 0 : (ref2 = daily.participants) === null || ref2 === void 0 ? void 0 : ref2.call(daily)) !== null && ref1 !== void 0 ? ref1 : {};
            var muteUpdates = {};
            transact_UNSTABLE(function(param) {
                var set = param.set;
                evts.forEach(function(ev) {
                    switch(ev.action){
                        case "participant-joined":
                            // Ignore non-owners in owner-only-broadcast
                            if (broadcast && !ev.participant.owner) return;
                            // Save new participant's cam & mic state for later
                            var isCamOn = !(0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(ev.participant, "video");
                            var isMicOn = !(0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(ev.participant, "audio");
                            set(orderedParticipantIdsState, function(prevIds) {
                                var newIds = prevIds.slice();
                                if (!isCamOn) {
                                    // Append cam-off participants to the end of the list
                                    return _toConsumableArray(newIds).concat([
                                        ev.participant.session_id
                                    ]);
                                }
                                // Find position of first cam-off & mic-off participant
                                var firstInactiveCamOffIndex = newIds.findIndex(function(id) {
                                    var ref;
                                    return (0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(participants[id], "video") && (0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(participants[id], "audio") && !((ref = participants[id]) === null || ref === void 0 ? void 0 : ref.local);
                                });
                                if (firstInactiveCamOffIndex >= 0) {
                                    // Insert new participant BEFORE first cam-off & mic-off participant
                                    newIds.splice(firstInactiveCamOffIndex, 0, ev.participant.session_id);
                                } else {
                                    // Otherwise just append new participant to the end of the list
                                    newIds.push(ev.participant.session_id);
                                }
                                return newIds.filter(Boolean);
                            });
                            if (isMicOn) {
                                // Actual check for muting happens later.
                                // This just adds to the updates object.
                                muteUpdates[ev.participant.session_id] = {
                                    setAudio: false
                                };
                            }
                            break;
                        case "participant-left":
                            set(orderedParticipantIdsState, function(prevIds) {
                                return prevIds.filter(function(id) {
                                    return id !== ev.participant.session_id;
                                });
                            });
                            set(participantMetaDataState, function(md) {
                                var newMetaData = _objectSpread({}, md);
                                delete newMetaData[ev.participant.session_id];
                                return newMetaData;
                            });
                            break;
                    }
                });
            });
            if (muteNewParticipants && daily && Object.keys(muteUpdates).length > 0) {
                daily.updateParticipants(muteUpdates);
            }
        };
    }, [
        broadcast,
        daily,
        muteNewParticipants
    ]));
    return null;
};
var ParticipantsProvider = function(param2) {
    var children = param2.children;
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useDaily */ .VI)();
    /**
     * Unmuted participant ids.
     */ var unmutedParticipantIds = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useParticipantIds */ .OV)({
        filter: (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(p) {
            return !(0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(p, "audio");
        }, [])
    });
    var prevUnmutedParticipantIds = (0,_hooks_usePreviousValue__WEBPACK_IMPORTED_MODULE_6__/* .usePreviousValue */ .z)(unmutedParticipantIds);
    var setMetaData = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useSetRecoilState */ .Zl)(participantMetaDataState);
    /**
     * Update last_active_date whenever a participant unmutes.
     */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var newlyUnmutedIds = unmutedParticipantIds.filter(function(id) {
            return !prevUnmutedParticipantIds.includes(id);
        });
        if (!newlyUnmutedIds.length) return;
        setMetaData(function(m) {
            var newMetaData = _objectSpread({}, m);
            newlyUnmutedIds.forEach(function(id) {
                newMetaData[id] = _objectSpread({}, newMetaData[id], {
                    last_active_date: new Date()
                });
            });
            return newMetaData;
        });
    }, [
        prevUnmutedParticipantIds,
        setMetaData,
        unmutedParticipantIds
    ]);
    var localSessionId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useLocalSessionId */ .q5)();
    var isLocalOwner = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useParticipantProperty */ .ou)(localSessionId, "owner");
    /**
     * Swaps the position of 2 participants identified by their session_id.
     */ var swapParticipantPosition = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function(id1, id2) {
            /**
           * Ignore in the following cases:
           * - id1 and id2 are equal
           * - one of both ids is not set
           */ if (id1 === id2 || !id1 || !id2) return;
            set(orderedParticipantIdsState, function(prevIds) {
                var newIds = prevIds.slice();
                var idx1 = prevIds.indexOf(id1);
                var idx2 = prevIds.indexOf(id2);
                /**
             * Could not find one of both ids in array.
             * This can be due to a race condition when a participant leaves,
             * while a swap of positions is triggered.
             */ if (idx1 === -1 || idx2 === -1) return prevIds;
                newIds[idx1] = id2;
                newIds[idx2] = id1;
                return newIds;
            });
        };
    }, []);
    var muteAll = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function() {
            var muteFutureParticipants = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            if (!isLocalOwner) return;
            set(muteNewParticipantsState, muteFutureParticipants);
            if (!unmutedParticipantIds.length) return;
            daily.updateParticipants(unmutedParticipantIds.reduce(function(o, id) {
                if (id === localSessionId) return o;
                o[id] = {
                    setAudio: false
                };
                return o;
            }, {}));
        };
    }, [
        daily,
        isLocalOwner,
        localSessionId,
        unmutedParticipantIds
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ParticipantsContext.Provider, {
        value: {
            muteAll: muteAll,
            swapParticipantPosition: swapParticipantPosition
        },
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ParticipantsEventsHandler, {})
        ]
    });
};
var useParticipants = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(ParticipantsContext);
};
/**
 * Returns the session_id for the participant that should be rendered
 * prominently in speaker or mobile view.
 */ var useCurrentSpeakerId = function() {
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useDaily */ .VI)();
    var localSessionId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useLocalSessionId */ .q5)();
    var orderedParticipantIds = useOrderedParticipantIds();
    var activeSpeakerId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useActiveSpeakerId */ .fu)({
        filter: (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(id) {
            var isRemoteSpeaker = orderedParticipantIds.includes(id);
            if (orderedParticipantIds.length) return isRemoteSpeaker && id !== localSessionId;
            return id === localSessionId;
        }, [
            localSessionId,
            orderedParticipantIds
        ])
    });
    var ref5 = _slicedToArray((0,_lib_state_layout__WEBPACK_IMPORTED_MODULE_8__/* .usePinnedId */ .Sg)(), 1), pinnedId = ref5[0];
    var participantMetaData = useParticipantMetaData();
    var broadcastRole = (0,_hooks_useCallConfig__WEBPACK_IMPORTED_MODULE_5__/* .useCallConfig */ .A)().broadcastRole;
    if (!daily) return null;
    /**
   * Ensure activeParticipant is still present in the call.
   * The activeParticipant only updates to a new active participant so
   * if everyone else is muted when AP leaves, the value will be stale.
   */ var isPresent = orderedParticipantIds.includes(activeSpeakerId);
    var isPinnedPresent = orderedParticipantIds.includes(pinnedId) || pinnedId === localSessionId;
    if (isPinnedPresent) return pinnedId;
    var participants = Object.values(daily.participants());
    if (!isPresent && orderedParticipantIds.length > 0 && orderedParticipantIds.every(function(id) {
        var ref;
        var p1 = participants.find(function(p) {
            return p.session_id === id;
        });
        return (0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(p1, "audio") && !(participantMetaData === null || participantMetaData === void 0 ? void 0 : (ref = participantMetaData[id]) === null || ref === void 0 ? void 0 : ref.last_active_date);
    })) {
        var ref3;
        // Return first cam on participant in case everybody is muted and nobody ever talked
        // or first remote participant, in case everybody's cam is muted, too.
        return (ref3 = orderedParticipantIds.find(function(id) {
            var p2 = participants.find(function(p) {
                return p.session_id === id;
            });
            return !(0,_lib_participants__WEBPACK_IMPORTED_MODULE_7__/* .isParticipantTrackOff */ .FD)(p2, "video");
        })) !== null && ref3 !== void 0 ? ref3 : orderedParticipantIds === null || orderedParticipantIds === void 0 ? void 0 : orderedParticipantIds[0];
    }
    var sorted = orderedParticipantIds.slice().sort(function(a, b) {
        var ref, ref6;
        var lastActiveA = participantMetaData === null || participantMetaData === void 0 ? void 0 : (ref = participantMetaData[a]) === null || ref === void 0 ? void 0 : ref.last_active_date;
        var lastActiveB = participantMetaData === null || participantMetaData === void 0 ? void 0 : (ref6 = participantMetaData[b]) === null || ref6 === void 0 ? void 0 : ref6.last_active_date;
        if (lastActiveA > lastActiveB) return 1;
        if (lastActiveA < lastActiveB) return -1;
        return 0;
    }).reverse();
    var fallback = broadcastRole === "attendee" ? null : localSessionId;
    var ref4;
    return isPresent ? activeSpeakerId : (ref4 = sorted === null || sorted === void 0 ? void 0 : sorted[0]) !== null && ref4 !== void 0 ? ref4 : fallback;
};


/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ih": function() { return /* binding */ useTracks; },
/* harmony export */   "Zs": function() { return /* binding */ MAX_RECENT_SPEAKER_COUNT; },
/* harmony export */   "iP": function() { return /* binding */ useMaxCamSubscriptions; },
/* harmony export */   "z8": function() { return /* binding */ TracksProvider; }
/* harmony export */ });
/* unused harmony export useRecentSpeakerIds */
/* harmony import */ var _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _daily_shared_contexts_Snackbar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4017);
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4283);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9378);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2031);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4480);
/* harmony import */ var _features_breakouts_hooks_useBreakoutSessionState__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1925);
/* harmony import */ var _hooks_useCallConfig__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6081);
/* harmony import */ var _lib_participants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1975);
/* harmony import */ var _lib_query__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5184);
/* harmony import */ var _lib_state_layout__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7556);
/* harmony import */ var _ParticipantsProvider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9394);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}















/**
 * Maximum amount of concurrently subscribed or staged most recent speakers.
 */ var MAX_RECENT_SPEAKER_COUNT = 16;
/**
 * Threshold up to which all cams will be subscribed to or staged.
 * If the remote participant count passes this threshold,
 * cam subscriptions are defined by UI view modes.
 */ var SUBSCRIBE_OR_STAGE_ALL_VIDEO_THRESHOLD = 9;
var TracksContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_6__.createContext)(null);
var maxCamSubscriptionsState = (0,recoil__WEBPACK_IMPORTED_MODULE_7__/* .atom */ .cn)({
    key: "max-cam-subscriptions",
    default: null
});
var useMaxCamSubscriptions = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_7__/* .useRecoilValue */ .sJ)(maxCamSubscriptionsState);
};
var TracksEffects = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_6__.memo)(function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$)().t;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().query;
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useDaily */ .VI)();
    var optimizeLargeCalls = (0,_hooks_useCallConfig__WEBPACK_IMPORTED_MODULE_9__/* .useCallConfig */ .A)().optimizeLargeCalls;
    var topology1 = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useNetwork */ .LN)().topology;
    var setMaxCamSubscriptions = (0,recoil__WEBPACK_IMPORTED_MODULE_7__/* .useSetRecoilState */ .Zl)(maxCamSubscriptionsState);
    var addMessage = (0,_daily_shared_contexts_Snackbar__WEBPACK_IMPORTED_MODULE_2__.useSnackbar)().addMessage;
    var orderedParticipantIds = (0,_ParticipantsProvider__WEBPACK_IMPORTED_MODULE_12__/* .useOrderedParticipantIds */ .o8)();
    var recentSpeakerIds = useRecentSpeakerIds();
    var localSessionId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useLocalSessionId */ .q5)();
    var breakoutStatus = (0,_features_breakouts_hooks_useBreakoutSessionState__WEBPACK_IMPORTED_MODULE_8__/* .useBreakoutSessionState */ .V)().breakoutStatus;
    var remoteParticipantIds = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useParticipantIds */ .OV)({
        filter: "remote"
    });
    /**
   * Automatically update audio, screenAudio and screenVideo subscriptions.
   */ (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (!daily || daily.isDestroyed() || !topology1) return;
        /**
     * A little throttling as we want daily-js to have some room to breathe ☺️
     */ var timeout = setTimeout(function() {
            var participants = daily.participants();
            var updates = remoteParticipantIds.reduce(function(u, id) {
                // Ignore undefined, local or screenshare participant ids
                if (!id || id === localSessionId) return u;
                var isSpeaker = recentSpeakerIds.includes(id) || !(0,_lib_participants__WEBPACK_IMPORTED_MODULE_10__/* .isParticipantTrackOff */ .FD)(participants[id], "audio");
                var hasSubscribed = function(type) {
                    var ref, ref1, ref2;
                    return (ref = participants[id]) === null || ref === void 0 ? void 0 : (ref1 = ref.tracks) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[type]) === null || ref2 === void 0 ? void 0 : ref2.subscribed;
                };
                var isRelevant = orderedParticipantIds.includes(id);
                var shouldSubscribe = function(type) {
                    // If we're not in SFU, no track subscriptions!
                    if (topology1 !== "sfu") return true;
                    // When optimized for large calls (and in SFU) only subscribe to speakers.
                    if (optimizeLargeCalls && type === "audio" && breakoutStatus !== "ongoing" // during a breakout session we can't reliably determine a speaker
                    ) return isSpeaker;
                    // Otherwise only subscribe to relevant participants.
                    return isRelevant;
                };
                /**
         * Updates the subscription update object for the current participant and given track type.
         * @param type The track type to update the subscription for.
         */ var setSubscribedTrack = function(type) {
                    var _hasSubscribed = hasSubscribed(type);
                    var _shouldSubscribe = shouldSubscribe(type);
                    if (!_hasSubscribed && _shouldSubscribe || _hasSubscribed && !_shouldSubscribe) {
                        if (typeof u[id] !== "object") {
                            u[id] = {
                                setSubscribedTracks: {}
                            };
                        }
                        u[id].setSubscribedTracks[type] = _shouldSubscribe;
                    }
                };
                /**
         * In optimized calls:
         * - subscribe to speakers we're not subscribed to, yet
         * - unsubscribe from non-speakers we're subscribed to
         * In non-optimized calls:
         * - subscribe to all who we're not to subscribed to, yet
         */ setSubscribedTrack("audio");
                /**
         * Update screen subscriptions based on orderedParticipantIds.
         */ setSubscribedTrack("screenAudio");
                setSubscribedTrack("screenVideo");
                return u;
            }, {});
            if (Object.keys(updates).length === 0 || daily.isDestroyed()) return;
            daily.updateParticipants(updates);
        }, 100);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        breakoutStatus,
        daily,
        localSessionId,
        optimizeLargeCalls,
        orderedParticipantIds,
        recentSpeakerIds,
        remoteParticipantIds,
        topology1, 
    ]);
    /**
   * Notify user when pushed out of recent speakers queue.
   */ var showMutedMessage = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var ref;
        if (!daily || !optimizeLargeCalls) return;
        if (recentSpeakerIds.some(function(id) {
            return id === localSessionId;
        })) {
            showMutedMessage.current = true;
            return;
        }
        if (showMutedMessage.current && !(0,_lib_participants__WEBPACK_IMPORTED_MODULE_10__/* .isParticipantTrackOff */ .FD)((ref = daily.participants()) === null || ref === void 0 ? void 0 : ref.local, "audio")) {
            daily.setLocalAudio(false);
            addMessage({
                content: t("notification.micMutedAutomatically")
            });
            showMutedMessage.current = false;
        }
    }, [
        addMessage,
        daily,
        localSessionId,
        optimizeLargeCalls,
        recentSpeakerIds,
        t, 
    ]);
    (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useThrottledDailyEvent */ .CH)("participant-joined", (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function() {
        var _ref = _asyncToGenerator(_home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(evts) {
            var ref, ids, topology, updates;
            return _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        ids = evts.map(function(ev) {
                            return ev.participant.session_id;
                        });
                        _ctx.next = 4;
                        return daily.getNetworkTopology();
                    case 4:
                        _ctx.t1 = ref = _ctx.sent;
                        _ctx.t0 = _ctx.t1 === null;
                        if (_ctx.t0) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.t0 = ref === void 0;
                    case 8:
                        if (!_ctx.t0) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.t2 = void 0;
                        _ctx.next = 13;
                        break;
                    case 12:
                        _ctx.t2 = ref.topology;
                    case 13:
                        topology = _ctx.t2;
                        updates = ids.reduce(function(o, id) {
                            if (topology === "peer") {
                                o[id] = {
                                    setSubscribedTracks: true
                                };
                            }
                            return o;
                        }, {});
                        if (!(Object.keys(updates).length === 0)) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 17:
                        daily.updateParticipants(updates);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(evts) {
            return _ref.apply(this, arguments);
        };
    }(), [
        daily
    ]));
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (query.max_cam_subs) {
            var maxSubs = parseInt((0,_lib_query__WEBPACK_IMPORTED_MODULE_14__/* .getQueryParam */ .P)("max_cam_subs", query), 10);
            if (maxSubs && !Number.isNaN(Math.abs(maxSubs))) {
                setMaxCamSubscriptions(maxSubs);
            }
        }
    }, [
        query,
        setMaxCamSubscriptions
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (optimizeLargeCalls) {
            setMaxCamSubscriptions(36);
        }
    }, [
        optimizeLargeCalls,
        setMaxCamSubscriptions
    ]);
    return null;
});
var TracksProvider = function(param) {
    var children = param.children;
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useDaily */ .VI)();
    var topology = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useNetwork */ .LN)().topology;
    var viewMode = (0,_lib_state_layout__WEBPACK_IMPORTED_MODULE_11__/* .useViewMode */ .mJ)();
    var recentSpeakerIds = useRecentSpeakerIds();
    var localSessionId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useLocalSessionId */ .q5)();
    var remoteParticipantIds = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useParticipantIds */ .OV)({
        filter: "remote"
    });
    var subscribeToCam = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function(id) {
        /**
       * Ignore undefined, local or screenshare.
       */ if (!id || id === localSessionId) return;
        daily.updateParticipant(id, {
            setSubscribedTracks: {
                video: true
            }
        });
    }, [
        daily,
        localSessionId
    ]);
    var lastSubscriptions = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)({});
    /**
   * Updates cam subscriptions based on passed subscribedIds and stagedIds.
   * For ids not provided, cam tracks will be unsubscribed from.
   *
   * @param subscribedIds Participant ids whose cam tracks should be subscribed to.
   * @param stagedIds Participant ids whose cam tracks should be staged.
   */ var updateCamSubscriptions = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function(subscribedIds) {
        var stagedIds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        if (!daily) return;
        // If total number of remote participants is less than a threshold, simply
        // stage all remote cams that aren't already marked for subscription.
        // Otherwise, honor the provided stagedIds, with recent speakers appended
        // who aren't already marked for subscription.
        if (remoteParticipantIds.length <= SUBSCRIBE_OR_STAGE_ALL_VIDEO_THRESHOLD) {
            stagedIds = remoteParticipantIds.filter(function(id) {
                return !subscribedIds.includes(id);
            });
        } else {
            if (viewMode !== "grid") {
                var _stagedIds;
                (_stagedIds = stagedIds).push.apply(_stagedIds, _toConsumableArray(recentSpeakerIds.filter(function(id) {
                    return !subscribedIds.includes(id);
                })));
            }
        }
        // Assemble updates to get to desired cam subscriptions
        var updates = remoteParticipantIds.reduce(function(u, id) {
            var ref, ref3, ref4, ref5;
            var desiredSubscription;
            var currentSubscription = (ref = daily.participants()) === null || ref === void 0 ? void 0 : (ref3 = ref[id]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.tracks) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.video) === null || ref5 === void 0 ? void 0 : ref5.subscribed;
            // Ignore undefined, local or screenshare participant ids
            if (!id || id === localSessionId) return u;
            // Decide on desired cam subscription for this participant:
            // subscribed, staged, or unsubscribed
            if (subscribedIds.includes(id) || topology !== "sfu") {
                desiredSubscription = true;
            } else if (stagedIds.includes(id)) {
                desiredSubscription = "staged";
            } else {
                desiredSubscription = false;
            }
            // Skip if we already have the desired subscription to this
            // participant's cam
            if (desiredSubscription === currentSubscription) return u;
            u[id] = {
                setSubscribedTracks: {
                    video: desiredSubscription
                }
            };
            return u;
        }, {});
        if (Object.keys(updates).length === 0) return;
        // Ignore API call if updates were already applied or callObject is destroyed
        if (fast_deep_equal__WEBPACK_IMPORTED_MODULE_4___default()(updates, lastSubscriptions.current) || daily.isDestroyed()) return;
        lastSubscriptions.current = _objectSpread({}, updates);
        daily.updateParticipants(updates);
    }, [
        daily,
        localSessionId,
        remoteParticipantIds,
        recentSpeakerIds,
        topology,
        viewMode, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TracksContext.Provider, {
        value: {
            subscribeToCam: subscribeToCam,
            updateCamSubscriptions: updateCamSubscriptions
        },
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TracksEffects, {})
        ]
    });
};
var useTracks = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_6__.useContext)(TracksContext);
};
var recentSpeakersState = (0,recoil__WEBPACK_IMPORTED_MODULE_7__/* .atom */ .cn)({
    key: "recent-speaker-ids",
    default: []
});
/**
 * Returns the ${MAX_RECENT_SPEAKER_COUNT} most recent speakers,
 * ordered by their most recent audio activity.
 */ var useRecentSpeakerIds = function() {
    var ref = _slicedToArray((0,recoil__WEBPACK_IMPORTED_MODULE_7__/* .useRecoilState */ .FV)(recentSpeakersState), 2), recentSpeakers = ref[0], setRecentSpeakers = ref[1];
    var activeSpeakerId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_3__/* .useActiveSpeakerId */ .fu)();
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        setRecentSpeakers(function(prevSpeakers) {
            return [
                activeSpeakerId, 
            ].concat(_toConsumableArray(prevSpeakers.filter(function(id) {
                return id !== activeSpeakerId;
            }))).filter(Boolean).slice(0, MAX_RECENT_SPEAKER_COUNT);
        });
    }, [
        activeSpeakerId,
        setRecentSpeakers
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        return recentSpeakers;
    }, [
        recentSpeakers
    ]);
};


/***/ }),

/***/ 1925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ useBreakoutSessionState; }
});

// EXTERNAL MODULE: ../daily-react/dist/daily-react.esm.js + 1 modules
var daily_react_esm = __webpack_require__(4283);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./features/breakouts/util/constants.ts
var constants = __webpack_require__(148);
// EXTERNAL MODULE: ./hooks/useCallConfig.ts
var useCallConfig = __webpack_require__(6081);
// EXTERNAL MODULE: ./hooks/useUserData.ts
var useUserData = __webpack_require__(7010);
// EXTERNAL MODULE: ./lib/userData.ts
var lib_userData = __webpack_require__(4218);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
;// CONCATENATED MODULE: ./features/breakouts/hooks/useMeetingSessionData.ts


// update this atom every time meeting-session-state-updated is called
var sessionDataState = (0,es/* atom */.cn)({
    key: "meeting-session-data-state",
    default: {}
});
var useMeetingSessionData = function() {
    var onMeetingSessionStateUpdated = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).onMeetingSessionStateUpdated;
    (0,daily_react_esm/* useDailyEvent */.VU)("meeting-session-state-updated", (0,es/* useRecoilCallback */._8)(function(param) {
        var set = param.set;
        return function(event) {
            set(sessionDataState, event.meetingSessionState.data);
            onMeetingSessionStateUpdated === null || onMeetingSessionStateUpdated === void 0 ? void 0 : onMeetingSessionStateUpdated(event);
        };
    }, [
        onMeetingSessionStateUpdated
    ]));
    var sessionData = (0,es/* useRecoilValue */.sJ)(sessionDataState);
    return {
        sessionData: sessionData
    };
};

;// CONCATENATED MODULE: ./features/breakouts/hooks/useBreakoutSessionState.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







/**
 * Returns all derived state from meeting session and user data.
 */ var useBreakoutSessionState = function() {
    var onMeetingSessionStateUpdated = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).onMeetingSessionStateUpdated;
    var ref17, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var enableBreakoutRooms = (0,useCallConfig/* useCallConfig */.A)().enableBreakoutRooms;
    var sessionData = useMeetingSessionData({
        onMeetingSessionStateUpdated: onMeetingSessionStateUpdated
    }).sessionData;
    var breakoutStatus = sessionData === null || sessionData === void 0 ? void 0 : (ref17 = sessionData.br) === null || ref17 === void 0 ? void 0 : ref17.status;
    var breakoutHost = sessionData === null || sessionData === void 0 ? void 0 : (ref1 = sessionData.br) === null || ref1 === void 0 ? void 0 : ref1.host;
    var ref16;
    var breakoutMapping = (0,react.useMemo)(function() {
        var ref;
        return (ref16 = sessionData === null || sessionData === void 0 ? void 0 : (ref = sessionData.br) === null || ref === void 0 ? void 0 : ref.mapping) !== null && ref16 !== void 0 ? ref16 : {};
    }, [
        sessionData === null || sessionData === void 0 ? void 0 : (ref2 = sessionData.br) === null || ref2 === void 0 ? void 0 : ref2.mapping
    ]);
    var endDate = (0,react.useMemo)(function() {
        var ref, ref18, ref19, ref20;
        if (!(sessionData === null || sessionData === void 0 ? void 0 : (ref = sessionData.br) === null || ref === void 0 ? void 0 : (ref18 = ref.config) === null || ref18 === void 0 ? void 0 : ref18.endDate)) return null;
        return new Date(sessionData === null || sessionData === void 0 ? void 0 : (ref19 = sessionData.br) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.config) === null || ref20 === void 0 ? void 0 : ref20.endDate);
    }, [
        sessionData === null || sessionData === void 0 ? void 0 : (ref3 = sessionData.br) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.config) === null || ref4 === void 0 ? void 0 : ref4.endDate
    ]);
    var localUserData = (0,useUserData/* useUserData */.v)([
        localSessionId
    ]);
    var currentRoomId = (ref5 = localUserData[localSessionId]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.br) === null || ref6 === void 0 ? void 0 : ref6.currentRoomId;
    var joinedState = (ref7 = localUserData[localSessionId]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.br) === null || ref8 === void 0 ? void 0 : ref8.status;
    var hasJoinedBreakout = currentRoomId && (sessionData === null || sessionData === void 0 ? void 0 : (ref9 = sessionData.br) === null || ref9 === void 0 ? void 0 : ref9.status) === "ongoing";
    var currentBreakoutRoom = {
        id: currentRoomId !== null && currentRoomId !== void 0 ? currentRoomId : constants/* MAIN_ROOM_IDENTIFIER */.b,
        name: breakoutMapping === null || breakoutMapping === void 0 ? void 0 : (ref10 = breakoutMapping[currentRoomId]) === null || ref10 === void 0 ? void 0 : ref10.name,
        users: breakoutMapping === null || breakoutMapping === void 0 ? void 0 : (ref11 = breakoutMapping[currentRoomId]) === null || ref11 === void 0 ? void 0 : ref11.users
    };
    var invited = Object.entries(breakoutMapping).find(function(param) {
        var _param = _slicedToArray(param, 2), room = _param[1];
        return room.users.includes(localSessionId);
    });
    var invitedBreakoutRoom = invited ? {
        id: invited === null || invited === void 0 ? void 0 : invited[0],
        name: invited === null || invited === void 0 ? void 0 : (ref12 = invited[1]) === null || ref12 === void 0 ? void 0 : ref12.name,
        users: invited === null || invited === void 0 ? void 0 : (ref13 = invited[1]) === null || ref13 === void 0 ? void 0 : ref13.users
    } : null;
    var allIds = (0,daily_react_esm/* useParticipantIds */.OV)();
    var breakoutUserDatas = (0,useUserData/* useUserData */.v)(allIds, (0,react.useCallback)(function(_id, data) {
        var ref;
        return Boolean(data === null || data === void 0 ? void 0 : (ref = data.br) === null || ref === void 0 ? void 0 : ref.currentRoomId);
    }, []));
    var anyBreakoutParticipantIds = Object.keys(breakoutUserDatas);
    var mainRoomParticipantIds = allIds.filter(function(id) {
        return !anyBreakoutParticipantIds.includes(id);
    });
    var userDatasAsArray = Object.entries(breakoutUserDatas);
    var breakoutParticipantIds = userDatasAsArray.filter(function(param) {
        var _param = _slicedToArray(param, 2), data = _param[1];
        var ref;
        return currentRoomId && (data === null || data === void 0 ? void 0 : (ref = data.br) === null || ref === void 0 ? void 0 : ref.currentRoomId) === currentRoomId;
    }).map(function(param) {
        var _param = _slicedToArray(param, 1), id = _param[0];
        return id;
    });
    var invitedUserDatas = (0,useUserData/* useUserData */.v)(allIds, (0,react.useCallback)(function(_id, data) {
        var ref;
        return (data === null || data === void 0 ? void 0 : (ref = data.br) === null || ref === void 0 ? void 0 : ref.status) === "invited";
    }, []));
    var invitedParticipants = Object.keys(invitedUserDatas);
    var breakoutMappingAsArray = Object.entries(breakoutMapping);
    var breakoutMappingValues = Object.values(breakoutMapping);
    /* Find all users in a room by its name*/ var breakoutParticipantsByRoomName = (0,react.useCallback)(function(roomName) {
        var ref;
        // get room id by its name
        var roomId = (ref = breakoutMappingAsArray.find(function(param) {
            var _param = _slicedToArray(param, 2), room = _param[1];
            return room.name === roomName;
        })) === null || ref === void 0 ? void 0 : ref[0];
        // get the actual location of participants by room name. for example:
        // user A is in room 1, and has been invited to room 2. their location remains
        // room 1 _until_ they accept the invite.
        return breakoutMappingValues.filter(function(m) {
            return m.name === roomName;
        }).map(function() {
            return userDatasAsArray.filter(function(param) {
                var _param = _slicedToArray(param, 2), userData = _param[1];
                return userData.br.currentRoomId === roomId;
            }).map(function(param) {
                var _param = _slicedToArray(param, 1), userId = _param[0];
                return userId;
            });
        });
    }, [
        breakoutMappingAsArray,
        breakoutMappingValues,
        userDatasAsArray
    ]);
    /* Find all users in a room by its id*/ var breakoutParticipantsByRoomId = (0,react.useCallback)(function(roomId) {
        var ref;
        return (ref = breakoutMapping[roomId]) === null || ref === void 0 ? void 0 : ref.users;
    }, [
        breakoutMapping
    ]);
    var participantsAskingForHelp = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: (0,react.useCallback)(function(p) {
            var ref;
            var userData = (0,lib_userData/* getPrebuiltUserData */.n1)(daily, p.local ? "local" : p.session_id);
            return (userData === null || userData === void 0 ? void 0 : (ref = userData.br) === null || ref === void 0 ? void 0 : ref.help) && !p.local;
        }, [
            daily
        ])
    });
    var userData1 = (0,useUserData/* useUserData */.v)([
        localSessionId
    ]);
    var isRequestingHelp = Boolean(userData1 === null || userData1 === void 0 ? void 0 : (ref14 = userData1[localSessionId]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.br) === null || ref15 === void 0 ? void 0 : ref15.help);
    if (!enableBreakoutRooms) {
        return {
            breakoutHost: "",
            breakoutParticipantsByRoomId: breakoutParticipantsByRoomId,
            breakoutMapping: {},
            breakoutParticipantsByRoomName: breakoutParticipantsByRoomName,
            breakoutParticipantIds: [],
            breakoutStatus: null,
            currentBreakoutRoom: currentBreakoutRoom,
            endDate: null,
            hasJoinedBreakout: false,
            invitedBreakoutRoom: null,
            invitedParticipants: [],
            joinedState: "idle",
            mainRoomParticipantIds: allIds,
            participantsAskingForHelp: [],
            isRequestingHelp: false
        };
    }
    return {
        breakoutHost: breakoutHost,
        breakoutParticipantsByRoomId: breakoutParticipantsByRoomId,
        breakoutMapping: breakoutMapping,
        breakoutParticipantsByRoomName: breakoutParticipantsByRoomName,
        breakoutParticipantIds: breakoutParticipantIds,
        breakoutStatus: breakoutStatus,
        currentBreakoutRoom: currentBreakoutRoom,
        endDate: endDate,
        hasJoinedBreakout: hasJoinedBreakout,
        invitedBreakoutRoom: invitedBreakoutRoom,
        invitedParticipants: invitedParticipants,
        joinedState: joinedState,
        mainRoomParticipantIds: mainRoomParticipantIds,
        participantsAskingForHelp: participantsAskingForHelp,
        isRequestingHelp: isRequestingHelp
    };
};


/***/ }),

/***/ 148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ MAIN_ROOM_IDENTIFIER; },
/* harmony export */   "n": function() { return /* binding */ DEFAULT_AMOUNT_OF_ROOMS; }
/* harmony export */ });
// we might want to make this configurable in the future. I'm imagining an option in the dashboard where
// owners can set a default amount of rooms.
var DEFAULT_AMOUNT_OF_ROOMS = 1;
var MAIN_ROOM_IDENTIFIER = "main-room";


/***/ }),

/***/ 2387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ isCloudRecordingType; }
/* harmony export */ });
function isCloudRecordingType(recType) {
    return recType === "cloud" || recType === "cloud-beta";
}


/***/ }),

/***/ 5398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWaitingRoom; },
/* harmony export */   "z": function() { return /* binding */ WaitingRoomProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4283);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _hooks_useSoundLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6240);




var WaitingRoomContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)(null);
var WaitingRoomProvider = function(param) {
    var children = param.children;
    var knockSound = (0,_hooks_useSoundLoader__WEBPACK_IMPORTED_MODULE_3__/* .useSoundLoader */ .Q)().knockSound;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useDaily */ .VI)();
    var handleWaitingParticipantAdded = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(ev) {
        var waiting = Object.entries(daily.waitingParticipants());
        /**
         * Only play knocking sound for first participant in waiting queue.
         */ if (ev.action === "waiting-participant-added" && waiting.length === 1) {
            knockSound.play();
        }
    }, [
        daily,
        knockSound
    ]);
    var waitingParticipants = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useWaitingParticipants */ .zy)({
        onWaitingParticipantAdded: handleWaitingParticipantAdded
    }).waitingParticipants;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (waitingParticipants.length === 0) {
            setShowModal(false);
        }
    }, [
        waitingParticipants
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WaitingRoomContext.Provider, {
        value: {
            setShowModal: setShowModal,
            showModal: showModal
        },
        children: children
    });
};
var useWaitingRoom = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(WaitingRoomContext);
};


/***/ }),

/***/ 8152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useAudioProcessor; }
/* harmony export */ });
/* harmony import */ var _daily_co_daily_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4061);
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4283);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9378);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2034);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4480);
/* harmony import */ var _useCallConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6081);







var audioProcessors = [
    "none",
    "noise-cancellation"
];
var COOKIE_KEY = "audio-processor";
var selectedAudioProcessorState = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .atom */ .cn)({
    key: "selected-audio-processor",
    default: "none",
    effects: [
        /**
     * Synchronizes atom state with cookie.
     */ function(param) {
            var onSet = param.onSet, setSelf = param.setSelf, trigger = param.trigger;
            // not all browsers support audio processing, e.g. Safari. in that case, there's
            // no reason to look at cookies.
            if (!_daily_co_daily_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].supportedBrowser */ .ZP.supportedBrowser().supportsAudioProcessing) return;
            if (trigger === "get") {
                var storedAudioProcessor = js_cookie__WEBPACK_IMPORTED_MODULE_3___default().get(COOKIE_KEY);
                if (audioProcessors.includes(storedAudioProcessor)) {
                    setSelf(storedAudioProcessor);
                }
            }
            onSet(function(newAudioProcessor) {
                if (newAudioProcessor === "none") {
                    js_cookie__WEBPACK_IMPORTED_MODULE_3___default().remove(COOKIE_KEY, {
                        sameSite: "none",
                        secure: true
                    });
                } else {
                    js_cookie__WEBPACK_IMPORTED_MODULE_3___default().set(COOKIE_KEY, newAudioProcessor, {
                        expires: new Date("Tue, 19 Jan 2038 03:14:07 GMT"),
                        sameSite: "none",
                        secure: true
                    });
                }
            });
        }, 
    ]
});
var noiseCancellationDisabledState = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .atom */ .cn)({
    key: "noise-cancellation-disabled",
    default: false
});
var useAudioProcessor = function() {
    var ref6, ref1;
    var enableNoiseCancellationUI = (0,_useCallConfig__WEBPACK_IMPORTED_MODULE_6__/* .useCallConfig */ .A)().enableNoiseCancellationUI;
    var waitForUpdate = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(false);
    var noiseCancellationDisabled = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilValue */ .sJ)(noiseCancellationDisabledState);
    var currentAudioProcessor = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilValue */ .sJ)(selectedAudioProcessorState);
    /* Update the atom state when the input settings change */ var ref2 = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useInputSettings */ .Nl)({
        onInputSettingsUpdated: (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilCallback */ ._8)(function(param) {
            var set = param.set;
            return function(event) {
                var ref, ref3, ref4, ref5;
                if (!((ref = event.inputSettings) === null || ref === void 0 ? void 0 : ref.audio)) return;
                var type = (ref3 = event.inputSettings) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.audio) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.processor) === null || ref5 === void 0 ? void 0 : ref5.type;
                switch(type){
                    case "noise-cancellation":
                        set(selectedAudioProcessorState, "noise-cancellation");
                        break;
                    case "none":
                        set(selectedAudioProcessorState, "none");
                        break;
                }
                if (waitForUpdate.current) {
                    waitForUpdate.current = false;
                    set(noiseCancellationDisabledState, false);
                }
            };
        }, [])
    }), inputSettings = ref2.inputSettings, updateInputSettings = ref2.updateInputSettings;
    var audioProcessorType = inputSettings === null || inputSettings === void 0 ? void 0 : (ref6 = inputSettings.audio) === null || ref6 === void 0 ? void 0 : (ref1 = ref6.processor) === null || ref1 === void 0 ? void 0 : ref1.type;
    /* Update the input settings */ var setAudioProcessor = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(audioProcessor) {
        if (!enableNoiseCancellationUI) return;
        try {
            var settings = {
                audio: {
                    processor: {
                        type: audioProcessor
                    }
                }
            };
            // old and new settings the same, so return
            if (fast_deep_equal__WEBPACK_IMPORTED_MODULE_2___default()(inputSettings === null || inputSettings === void 0 ? void 0 : inputSettings.audio, settings === null || settings === void 0 ? void 0 : settings.audio)) {
                return;
            }
            //  the current input settings is an empty object, and the new input settings
            //  do not actually change anything, so no-op
            if (fast_deep_equal__WEBPACK_IMPORTED_MODULE_2___default()(inputSettings, {}) && audioProcessor === "none") {
                return;
            }
            updateInputSettings(settings);
        } catch (e) {}
    }, [
        enableNoiseCancellationUI,
        inputSettings,
        updateInputSettings
    ]);
    var handleNoiseCancellationChange = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function(isOn) {
            set(noiseCancellationDisabledState, true);
            waitForUpdate.current = true;
            setAudioProcessor(isOn ? "noise-cancellation" : "none");
        };
    }, [
        setAudioProcessor
    ]);
    return {
        noiseCancellationOn: audioProcessorType === "noise-cancellation",
        noiseCancellationDisabled: noiseCancellationDisabled,
        handleNoiseCancellationChange: handleNoiseCancellationChange,
        currentAudioProcessor: currentAudioProcessor,
        setAudioProcessor: setAudioProcessor
    };
};


/***/ }),

/***/ 416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useBackgroundEffect; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4283);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9378);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2034);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1752);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4480);
/* harmony import */ var _useCallConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6081);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








var sortedEffects = [
    "none",
    "soft-blur",
    "strong-blur",
    "vb-coffeeshop",
    "vb-forest",
    "vb-hills",
    "vb-library",
    "vb-lounge",
    "vb-ocean",
    "vb-office",
    "vb-palms",
    "vb-rollercoaster", 
];
var COOKIE_KEY = "bg-effect";
var selectedBackgroundEffectState = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .atom */ .cn)({
    key: "selected-background-effect",
    default: "none",
    effects: [
        /**
     * Synchronizes atom state with cookie.
     */ function(param) {
            var onSet = param.onSet, setSelf = param.setSelf, trigger = param.trigger;
            if (trigger === "get") {
                var storedBgEffect = js_cookie__WEBPACK_IMPORTED_MODULE_3___default().get(COOKIE_KEY);
                if (sortedEffects.includes(storedBgEffect)) {
                    setSelf(storedBgEffect);
                }
            }
            onSet(function(newEffect) {
                if (newEffect === "none") {
                    js_cookie__WEBPACK_IMPORTED_MODULE_3___default().remove(COOKIE_KEY, {
                        sameSite: "none",
                        secure: true
                    });
                } else {
                    js_cookie__WEBPACK_IMPORTED_MODULE_3___default().set(COOKIE_KEY, newEffect, {
                        expires: new Date("Tue, 19 Jan 2038 03:14:07 GMT"),
                        sameSite: "none",
                        secure: true
                    });
                }
            });
        }, 
    ]
});
var useBackgroundEffect = function() {
    var enableVideoProcessingUI = (0,_useCallConfig__WEBPACK_IMPORTED_MODULE_7__/* .useCallConfig */ .A)().enableVideoProcessingUI;
    var currentEffect = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilValue */ .sJ)(selectedBackgroundEffectState);
    var assetPrefix = (0,next_config__WEBPACK_IMPORTED_MODULE_4__["default"])().publicRuntimeConfig.assetPrefix;
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useDaily */ .VI)();
    var ref3 = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useInputSettings */ .Nl)({
        onInputSettingsUpdated: (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilCallback */ ._8)(function(param) {
            var set = param.set;
            return function(ev) {
                var ref, ref1;
                if (!enableVideoProcessingUI) return;
                var newEffect = "none";
                var _inputSettings;
                var video = ((_inputSettings = ev.inputSettings) !== null && _inputSettings !== void 0 ? _inputSettings : {}).video;
                if ((video === null || video === void 0 ? void 0 : (ref = video.processor) === null || ref === void 0 ? void 0 : ref.type) === "background-blur") {
                    var config = video.processor.config;
                    var ref2;
                    var level = (ref2 = config === null || config === void 0 ? void 0 : config.strength) !== null && ref2 !== void 0 ? ref2 : 0;
                    if (level === 0) {
                        newEffect = "none";
                    } else if (level < 0.5) {
                        newEffect = "soft-blur";
                    } else {
                        newEffect = "strong-blur";
                    }
                    set(selectedBackgroundEffectState, newEffect);
                } else if ((video === null || video === void 0 ? void 0 : (ref1 = video.processor) === null || ref1 === void 0 ? void 0 : ref1.type) === "background-image") {
                    var config1 = video.processor.config;
                    if (config1.source) {
                        var url = new URL(config1.source);
                        var match = url.pathname.match(new RegExp(sortedEffects.filter(function(fx) {
                            return fx.startsWith("vb-");
                        }).join("|")));
                        if (match) {
                            newEffect = match[0];
                            set(selectedBackgroundEffectState, newEffect);
                        }
                    }
                } else {
                    set(selectedBackgroundEffectState, "none");
                }
            };
        }, [
            enableVideoProcessingUI
        ])
    }), inputSettings1 = ref3.inputSettings, updateInputSettings = ref3.updateInputSettings;
    var selectEffect = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function(effect) {
        try {
            var type = "none";
            var blurLevel = 0;
            if (effect.endsWith("-blur")) {
                type = "background-blur";
                switch(effect){
                    case "strong-blur":
                        blurLevel = 1;
                        break;
                    case "soft-blur":
                        blurLevel = 0.2;
                        break;
                }
            } else if (effect.startsWith("vb-")) {
                type = "background-image";
            }
            var settings = null;
            switch(type){
                case "none":
                    settings = {
                        video: {
                            processor: {
                                type: type
                            }
                        }
                    };
                    break;
                case "background-blur":
                    settings = {
                        video: {
                            processor: {
                                type: type,
                                config: {
                                    strength: blurLevel
                                }
                            }
                        }
                    };
                    break;
                case "background-image":
                    var _location = window.location, hostname = _location.hostname, port = _location.port, protocol = _location.protocol;
                    // Check if assetPrefix already contains FQDN
                    var prefix = assetPrefix.match(/^https?\:\/\//) ? assetPrefix : "".concat(protocol, "//").concat(hostname, ":").concat(port).concat(assetPrefix);
                    settings = {
                        video: {
                            processor: {
                                type: type,
                                config: {
                                    source: "".concat(prefix, "/backgrounds/").concat(effect, ".jpg")
                                }
                            }
                        }
                    };
                    break;
            }
            if (fast_deep_equal__WEBPACK_IMPORTED_MODULE_2___default()(inputSettings1, settings) || fast_deep_equal__WEBPACK_IMPORTED_MODULE_2___default()(inputSettings1, {}) && effect === "none") return;
            updateInputSettings(settings);
        } catch (e) {}
    }, [
        assetPrefix,
        inputSettings1,
        updateInputSettings
    ]);
    (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useDailyEvent */ .VU)("started-camera", (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(_asyncToGenerator(_home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, inputSettings;
        return _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!(!enableVideoProcessingUI || !daily)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    _ctx.next = 5;
                    return daily.getInputSettings();
                case 5:
                    inputSettings = _ctx.sent;
                    // Apply prebuilt bg-effect cookie if and only if no input settings are
                    // currently applied in daily-js. This is to prevent overriding settings
                    // provided in join(), createFrame(), createCallObject() or by calling
                    // updateInputSettings() directly. Without any such settings applied, the
                    // inputSettings object will be empty {}.
                    if (currentEffect && !(inputSettings === null || inputSettings === void 0 ? void 0 : (ref = inputSettings.video) === null || ref === void 0 ? void 0 : ref.processor)) {
                        selectEffect(currentEffect);
                    }
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        currentEffect,
        daily,
        enableVideoProcessingUI,
        selectEffect
    ]));
    return {
        currentEffect: currentEffect,
        effects: sortedEffects,
        selectEffect: selectEffect
    };
};


/***/ }),

/***/ 6081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useCallConfig; }
/* harmony export */ });
/* harmony import */ var _daily_co_daily_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4061);
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4283);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _features_recording_util_isCloudRecordingType__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2387);
/* harmony import */ var _lib_browserConfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7530);
/* harmony import */ var _lib_state_custom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3510);
/* harmony import */ var _lib_state_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7556);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








var useCallConfig = function() {
    var ref21, ref1;
    var room = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .useRoom */ .NW)();
    var ref2 = _slicedToArray((0,_lib_state_layout__WEBPACK_IMPORTED_MODULE_6__/* .usePreferredViewMode */ .Ut)(), 2), setPreferredViewMode = ref2[1];
    var ref3 = _slicedToArray((0,_lib_state_custom__WEBPACK_IMPORTED_MODULE_5__/* .useMaxGridTilesPerPage */ .lW)(), 2), setMaxGridTilesPerPage = ref3[1];
    var ref4 = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_1__/* .usePermissions */ .TE)(), canSendScreenAudio = ref4.canSendScreenAudio, canSendScreenVideo = ref4.canSendScreenVideo;
    /**
   * Apply Prebuilt UI constraints, when experimental_optimize_large_calls is set.
   */ (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var ref;
        var optimizeLargeCalls = room === null || room === void 0 ? void 0 : (ref = room.config) === null || ref === void 0 ? void 0 : ref.experimental_optimize_large_calls;
        if (!optimizeLargeCalls) return;
        setMaxGridTilesPerPage(12);
    // TBC: For now, start the call in Speaker view to match the group call default
    // setPreferredViewMode('grid');
    }, [
        room,
        setMaxGridTilesPerPage,
        setPreferredViewMode
    ]);
    if (!room) return {
        broadcast: null,
        broadcastRole: null,
        poweredByDaily: false
    };
    var config = room.config, domainConfig = room.domainConfig, tokenConfig = room.tokenConfig;
    var ref5;
    var broadcast = (ref5 = config === null || config === void 0 ? void 0 : config.owner_only_broadcast) !== null && ref5 !== void 0 ? ref5 : null;
    var isOwner = tokenConfig === null || tokenConfig === void 0 ? void 0 : tokenConfig.is_owner;
    var hasFullUIControls = !broadcast || broadcast && isOwner;
    var ref6;
    var recordingType = (ref6 = tokenConfig === null || tokenConfig === void 0 ? void 0 : tokenConfig.enable_recording) !== null && ref6 !== void 0 ? ref6 : config === null || config === void 0 ? void 0 : config.enable_recording;
    var browser =  false ? 0 : bowser__WEBPACK_IMPORTED_MODULE_2___default().parse(window.navigator.userAgent);
    var supportsLocalRecording = (browser === null || browser === void 0 ? void 0 : (ref21 = browser.platform) === null || ref21 === void 0 ? void 0 : ref21.type) === "desktop" && (browser === null || browser === void 0 ? void 0 : (ref1 = browser.engine) === null || ref1 === void 0 ? void 0 : ref1.name) === "Blink";
    var isLocalRecordingReady = recordingType === "local" && supportsLocalRecording;
    var ref7;
    var recordingsBucket = (ref7 = config === null || config === void 0 ? void 0 : config.recordings_bucket) !== null && ref7 !== void 0 ? ref7 : domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.recordings_bucket;
    var isCloudRecordingAllowed = !domainConfig.hipaa || domainConfig.hipaa && recordingsBucket;
    var isCloudRecordingReady = isCloudRecordingAllowed && (0,_features_recording_util_isCloudRecordingType__WEBPACK_IMPORTED_MODULE_7__/* .isCloudRecordingType */ .x)(recordingType);
    var enableRecording = hasFullUIControls && (isLocalRecordingReady || isCloudRecordingReady) ? recordingType : null;
    var ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    return {
        broadcast: broadcast,
        broadcastRole: broadcast ? isOwner ? "owner" : "attendee" : null,
        enableBreakoutRooms: (ref8 = config === null || config === void 0 ? void 0 : config.enable_breakout_rooms) !== null && ref8 !== void 0 ? ref8 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_breakout_rooms),
        enableEmojiReactions: (ref9 = config === null || config === void 0 ? void 0 : config.enable_emoji_reactions) !== null && ref9 !== void 0 ? ref9 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_emoji_reactions),
        enableAdvancedChat: (ref10 = config === null || config === void 0 ? void 0 : config.enable_advanced_chat) !== null && ref10 !== void 0 ? ref10 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_advanced_chat),
        enableChat: (ref11 = config === null || config === void 0 ? void 0 : config.enable_chat) !== null && ref11 !== void 0 ? ref11 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_chat),
        enableImplicitPassiveParticipant: !!(config === null || config === void 0 ? void 0 : config["enable_implicit_passive_participants"]),
        enableNetworkUI: (ref12 = config === null || config === void 0 ? void 0 : config.enable_network_ui) !== null && ref12 !== void 0 ? ref12 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_network_ui),
        enableNoiseCancellationUI: !(0,_lib_browserConfig__WEBPACK_IMPORTED_MODULE_4__/* .isSafari */ .G6)() && _daily_co_daily_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].supportedBrowser */ .ZP.supportedBrowser().supportsAudioProcessing && ((ref13 = config === null || config === void 0 ? void 0 : config.enable_noise_cancellation_ui) !== null && ref13 !== void 0 ? ref13 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_noise_cancellation_ui)),
        enablePeopleUI: (ref15 = (ref14 = config === null || config === void 0 ? void 0 : config.enable_people_ui) !== null && ref14 !== void 0 ? ref14 : domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_people_ui) !== null && ref15 !== void 0 ? ref15 : true,
        enablePIPUI: (ref16 = config === null || config === void 0 ? void 0 : config.enable_pip_ui) !== null && ref16 !== void 0 ? ref16 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_pip_ui),
        enableHandRaising: (ref17 = config === null || config === void 0 ? void 0 : config.enable_hand_raising) !== null && ref17 !== void 0 ? ref17 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_hand_raising),
        enableRecording: enableRecording,
        enableRecordingUI: (ref18 = tokenConfig === null || tokenConfig === void 0 ? void 0 : tokenConfig.enable_recording_ui) !== null && ref18 !== void 0 ? ref18 : !!enableRecording,
        enableScreenShare: hasFullUIControls && ((ref19 = tokenConfig === null || tokenConfig === void 0 ? void 0 : tokenConfig.enable_screenshare) !== null && ref19 !== void 0 ? ref19 : config === null || config === void 0 ? void 0 : config.enable_screenshare) && _daily_co_daily_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].supportedBrowser */ .ZP.supportedBrowser().supportsScreenShare && (canSendScreenAudio || canSendScreenVideo),
        enableVideoProcessingUI: _daily_co_daily_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].supportedBrowser */ .ZP.supportedBrowser().supportsVideoProcessing && ((ref20 = config === null || config === void 0 ? void 0 : config.enable_video_processing_ui) !== null && ref20 !== void 0 ? ref20 : !!(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.enable_video_processing_ui)),
        optimizeLargeCalls: config === null || config === void 0 ? void 0 : config.experimental_optimize_large_calls,
        poweredByDaily: domainConfig && "hide_daily_branding" in domainConfig ? !(domainConfig === null || domainConfig === void 0 ? void 0 : domainConfig.hide_daily_branding) : false
    };
};


/***/ }),

/***/ 468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useCustomIntegrations; }
/* harmony export */ });
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4283);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4480);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var customIntegrationsState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: "custom-integrations",
    default: {}
});
var SESSION_STATE_KEY = "integrations";
var integrationsMeetingState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: "integrations-meeting-state",
    default: {}
});
var locallyRunningIntegrationsState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
    key: "locally-running-integrations",
    default: []
});
/**
 * Returns custom integrations and a setter to change them.
 */ var useCustomIntegrations = function() {
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__/* .useDaily */ .VI)();
    var runningLocalIntegrations = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(locallyRunningIntegrationsState);
    var runningSharedIntegrations = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(integrationsMeetingState);
    (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__/* .useDailyEvent */ .VU)("meeting-session-state-updated", (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function(ev) {
            var ref;
            var state = ev.meetingSessionState;
            var ref1;
            set(integrationsMeetingState, (ref1 = (ref = state.data) === null || ref === void 0 ? void 0 : ref.integrations) !== null && ref1 !== void 0 ? ref1 : {});
        };
    }, []));
    var integrations = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(customIntegrationsState);
    var _integrationsAsArray = Object.entries(integrations).map(function(param) {
        var _param = _slicedToArray(param, 2), id = _param[0], integration = _param[1];
        return _objectSpread({}, integration, {
            id: id
        });
    });
    var localSessionId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__/* .useLocalSessionId */ .q5)();
    var ref2 = _slicedToArray((0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__/* .useParticipantProperty */ .ou)(localSessionId, [
        "owner",
        "user_id",
        "user_name", 
    ]), 3), isOwner = ref2[0], userId = ref2[1], userName = ref2[2];
    var replacePlaceholders = function() {
        var src = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return src.replaceAll("{{session_id}}", localSessionId).replaceAll("{{user_id}}", userId).replaceAll("{{user_name}}", userName);
    };
    var isSharedWithLocalParticipant = function(integration) {
        if (typeof integration.shared === "boolean") return integration.shared;
        if (integration.shared === "owners") return isOwner;
        if (Array.isArray(integration.shared)) return integration.shared.includes(localSessionId);
        return false;
    };
    var meetingSessionState = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__/* .useMeetingSessionState */ .dv)();
    var mainIntegrations = _integrationsAsArray.filter(function(integration) {
        return integration.location === "main";
    }).map(function(integration) {
        var ref, ref3, ref4;
        return _objectSpread({}, integration, {
            src: replacePlaceholders(integration.src),
            running: integration.id in runningSharedIntegrations && isSharedWithLocalParticipant(integration) || runningLocalIntegrations.includes(integration.id),
            startedBy: meetingSessionState === null || meetingSessionState === void 0 ? void 0 : (ref = meetingSessionState.data) === null || ref === void 0 ? void 0 : (ref3 = ref.integrations) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[integration.id]) === null || ref4 === void 0 ? void 0 : ref4.startedBy
        });
    });
    var sidebarIntegrations = _integrationsAsArray.filter(function(integration) {
        return integration.location === "sidebar";
    }).map(function(integration) {
        return _objectSpread({}, integration, {
            src: replacePlaceholders(integration.src)
        });
    });
    var runningMainIntegrations = mainIntegrations.filter(function(i) {
        return i.running;
    });
    var setCustomIntegrations = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function(newVal) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(newVal)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _value = _slicedToArray(_step.value, 2), key = _value[0], val = _value[1];
                    if (!val.controlledBy) newVal[key].controlledBy = "*";
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            set(customIntegrationsState, newVal);
        };
    }, []);
    var startIntegration = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function(id) {
            var integration = mainIntegrations.find(function(m) {
                return m.id === id;
            });
            if (!(integration === null || integration === void 0 ? void 0 : integration.shared)) {
                set(locallyRunningIntegrationsState, function(ids) {
                    return _toConsumableArray(new Set(_toConsumableArray(ids).concat([
                        id
                    ])));
                });
                return;
            }
            var state = daily.meetingSessionState();
            var runningIntegrations = _objectSpread({}, state.data[SESSION_STATE_KEY]);
            runningIntegrations[id] = {
                shared: integration.shared,
                startedBy: localSessionId
            };
            daily.setMeetingSessionData(_defineProperty({}, SESSION_STATE_KEY, runningIntegrations), "shallow-merge");
        };
    }, [
        daily,
        localSessionId,
        mainIntegrations
    ]);
    var stopIntegration = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function(id) {
            var state = daily.meetingSessionState();
            var runningIntegrations = _objectSpread({}, state.data[SESSION_STATE_KEY]);
            if (!runningIntegrations[id]) {
                set(locallyRunningIntegrationsState, function(ids) {
                    return _toConsumableArray(ids).filter(function(i) {
                        return i !== id;
                    });
                });
                return;
            }
            delete runningIntegrations[id];
            daily.setMeetingSessionData(_defineProperty({}, SESSION_STATE_KEY, runningIntegrations), "shallow-merge");
        };
    }, [
        daily
    ]);
    var canControlIntegration = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(param) {
        var controlledBy = param.controlledBy;
        return controlledBy === "*" || controlledBy === "owners" && isOwner || Array.isArray(controlledBy) && controlledBy.includes(localSessionId);
    }, [
        isOwner,
        localSessionId
    ]);
    return {
        canControlIntegration: canControlIntegration,
        mainIntegrations: mainIntegrations,
        runningMainIntegrations: runningMainIntegrations,
        runningSharedIntegrations: runningSharedIntegrations,
        sidebarIntegrations: sidebarIntegrations,
        setCustomIntegrations: setCustomIntegrations,
        startIntegration: startIntegration,
        stopIntegration: stopIntegration
    };
};


/***/ }),

/***/ 2428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useDebugging; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);

var prebuiltDebuggerEnabledState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "prebuilt-debugger-enabled",
    default: false
});
var useDebugging = function() {
    var prebuiltDebuggerEnabled = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilValue */ .sJ)(prebuiltDebuggerEnabledState);
    var enablePrebuiltDebugger = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function() {
            set(prebuiltDebuggerEnabledState, true);
        };
    });
    var disablePrebuiltDebugger = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilCallback */ ._8)(function(param) {
        var set = param.set;
        return function() {
            set(prebuiltDebuggerEnabledState, false);
        };
    });
    return {
        prebuiltDebuggerEnabled: prebuiltDebuggerEnabled,
        enablePrebuiltDebugger: enablePrebuiltDebugger,
        disablePrebuiltDebugger: disablePrebuiltDebugger
    };
};


/***/ }),

/***/ 3584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ usePreviousValue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var usePreviousValue = function(value) {
    var prevValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        prevValue.current = value;
        return function() {
            prevValue.current = undefined;
        };
    });
    return prevValue.current;
};


/***/ }),

/***/ 2275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useScreens; }
/* harmony export */ });
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4283);
/* harmony import */ var _contexts_ParticipantsProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9394);


var useScreens = function() {
    var localSessionId = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__/* .useLocalSessionId */ .q5)();
    var orderedParticipantIds = (0,_contexts_ParticipantsProvider__WEBPACK_IMPORTED_MODULE_1__/* .useOrderedParticipantIds */ .o8)();
    var screens = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__/* .useScreenShare */ .N2)().screens;
    return screens.filter(function(screen) {
        return orderedParticipantIds.includes(screen.session_id) || screen.session_id === localSessionId;
    });
};


/***/ }),

/***/ 6240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ useSoundLoader; }
});

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./lib/state/custom.ts
var custom = __webpack_require__(3510);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./hooks/useSound.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var defaultNotMuted = function() {
    return false;
};
var useSound = function(src) {
    var isMuted = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultNotMuted;
    var audio = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var tag = document.querySelector('audio[src="'.concat(src, '"]'));
        if (tag) {
            audio.current = tag;
        } else {
            var t = document.createElement("audio");
            t.src = src;
            t.setAttribute("playsinline", "");
            document.body.appendChild(t);
            audio.current = t;
        }
    }, [
        src
    ]);
    var load = (0,react.useCallback)(function() {
        if (!audio.current) return;
        audio.current.load();
    }, [
        audio
    ]);
    var play = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!audio.current || isMuted())) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.prev = 2;
                    audio.current.currentTime = 0;
                    _ctx.next = 6;
                    return audio.current.play();
                case 6:
                    _ctx.next = 11;
                    break;
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](2);
                    console.error(_ctx.t0);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                8
            ]
        ]);
    })), [
        audio,
        isMuted
    ]);
    return {
        load: load,
        play: play
    };
};

;// CONCATENATED MODULE: ./hooks/useSoundLoader.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var useSoundLoader = function() {
    var assetPrefix = (0,config["default"])().publicRuntimeConfig.assetPrefix;
    var ref = _slicedToArray((0,custom/* useEnableJoinSound */.Xn)(), 1), enableJoinSound = ref[0];
    var isJoinSoundMuted = (0,react.useCallback)(function() {
        return !enableJoinSound;
    }, [
        enableJoinSound
    ]);
    var errorSound = useSound("".concat(assetPrefix, "/error.mp3"));
    var knockSound = useSound("".concat(assetPrefix, "/knock.mp3"));
    var joinSound = useSound("".concat(assetPrefix, "/join.mp3"), isJoinSoundMuted);
    var load = (0,react.useCallback)(function() {
        errorSound.load();
        knockSound.load();
        joinSound.load();
    }, [
        errorSound,
        knockSound,
        joinSound
    ]);
    return (0,react.useMemo)(function() {
        return {
            errorSound: errorSound,
            knockSound: knockSound,
            joinSound: joinSound,
            load: load
        };
    }, [
        errorSound,
        knockSound,
        joinSound,
        load
    ]);
};


/***/ }),

/***/ 6803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useStyleVariants; }
/* harmony export */ });
/* harmony import */ var _daily_shared_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9802);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _lib_state_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8890);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var useStyleVariants = function() {
    var ref = _slicedToArray((0,_lib_state_core__WEBPACK_IMPORTED_MODULE_2__/* .useIsMobile */ .dD)(), 1), isMobile = ref[0];
    var iconVariant = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isMobile ? 24 : 16;
    }, [
        isMobile
    ]);
    var isPortrait = (0,_daily_shared_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_0__.useMediaQuery)("(orientation: portrait)");
    var mobileLandscape = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isMobile && !isPortrait;
    }, [
        isMobile,
        isPortrait
    ]);
    var mobilePortrait = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isMobile && isPortrait;
    }, [
        isMobile,
        isPortrait
    ]);
    var textVariant = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isMobile ? "large" : "base";
    }, [
        isMobile
    ]);
    var textVariantSmall = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isMobile ? "base" : "small";
    }, [
        isMobile
    ]);
    var textVariantStrong = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isMobile ? "largestrong" : "strong";
    }, [
        isMobile
    ]);
    return {
        isPortrait: isPortrait,
        mobileLandscape: mobileLandscape,
        mobilePortrait: mobilePortrait,
        textVariant: textVariant,
        textVariantSmall: textVariantSmall,
        textVariantStrong: textVariantStrong,
        iconVariant: iconVariant
    };
};


/***/ }),

/***/ 7010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useUserData; }
/* harmony export */ });
/* harmony import */ var _daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4283);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9378);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4480);
/* harmony import */ var _lib_userData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4218);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var userDataState = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .atom */ .cn)({
    key: "user-data-state",
    default: {}
});
var noopFilter = function() {
    return true;
};
/**
 * Returns React-ified userData objects for each passed session_id.
 */ var useUserData = function(ids) {
    var filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noopFilter;
    var userData2 = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(userDataState);
    var daily = (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__/* .useDaily */ .VI)();
    (0,_daily_co_daily_react__WEBPACK_IMPORTED_MODULE_0__/* .useThrottledDailyEvent */ .CH)([
        "joined-meeting",
        "participant-joined",
        "participant-updated",
        "participant-left", 
    ], (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilCallback */ ._8)(function(param1) {
        var transact_UNSTABLE = param1.transact_UNSTABLE;
        return function(evts) {
            transact_UNSTABLE(function(param) {
                var get = param.get, set = param.set;
                var prev = get(userDataState);
                var newState = _objectSpread({}, prev);
                evts.forEach(function(ev) {
                    switch(ev.action){
                        case "joined-meeting":
                            {
                                var session_id = ev.participants.local.session_id;
                                var userData = (0,_lib_userData__WEBPACK_IMPORTED_MODULE_4__/* .getPrebuiltUserData */ .n1)(daily, "local");
                                newState[session_id] = userData;
                                break;
                            }
                        case "participant-joined":
                        case "participant-updated":
                            {
                                var session_id1 = ev.participant.session_id;
                                var userData1 = (0,_lib_userData__WEBPACK_IMPORTED_MODULE_4__/* .getPrebuiltUserData */ .n1)(daily, ev.participant.local ? "local" : session_id1);
                                newState[session_id1] = userData1;
                                break;
                            }
                        case "participant-left":
                            {
                                var session_id2 = ev.participant.session_id;
                                delete newState[session_id2];
                                break;
                            }
                    }
                });
                if (fast_deep_equal__WEBPACK_IMPORTED_MODULE_1___default()(prev, newState)) return;
                set(userDataState, newState);
            });
        };
    }, [
        daily
    ]));
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return Object.entries(userData2).filter(function(param) {
            var _param = _slicedToArray(param, 1), id = _param[0];
            return ids.includes(id);
        })// Apply custom filter
        .filter(function(param) {
            var _param = _slicedToArray(param, 2), id = _param[0], data = _param[1];
            return filter(id, data);
        })// Convert array back to object
        .reduce(function(res, param) {
            var _param = _slicedToArray(param, 2), id = _param[0], data = _param[1];
            res[id] = data;
            return res;
        }, {});
    }, [
        filter,
        ids,
        userData2
    ]);
};


/***/ }),

/***/ 5192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useVideoQuality; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var videoQualityState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "video-quality",
    default: "auto"
});
var useVideoQuality = function() {
    var ref = _slicedToArray((0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(videoQualityState), 2), videoQuality = ref[0], setVideoQuality = ref[1];
    return {
        videoQuality: videoQuality,
        setVideoQuality: setVideoQuality
    };
};


/***/ }),

/***/ 7530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ isAndroid; },
/* harmony export */   "G6": function() { return /* binding */ isSafari; },
/* harmony export */   "eS": function() { return /* binding */ isIOSMobile; },
/* harmony export */   "jI": function() { return /* binding */ isAndroidChrome; }
/* harmony export */ });
/* unused harmony export isFirefox */
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_0__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var isAndroidChrome = function(browserName) {
    var ref, ref1, ref2;
    var browser = bowser__WEBPACK_IMPORTED_MODULE_0___default().parse(navigator.userAgent);
    var name = browserName !== null && browserName !== void 0 ? browserName : browser === null || browser === void 0 ? void 0 : (ref = browser.browser) === null || ref === void 0 ? void 0 : ref.name;
    return name === "Chrome" && (browser === null || browser === void 0 ? void 0 : (ref1 = browser.platform) === null || ref1 === void 0 ? void 0 : ref1.type) === "mobile" && (browser === null || browser === void 0 ? void 0 : (ref2 = browser.os) === null || ref2 === void 0 ? void 0 : ref2.name) === "Android";
};
var isAndroid = function() {
    var ref, ref3;
    var browser = bowser__WEBPACK_IMPORTED_MODULE_0___default().parse(navigator.userAgent);
    return (browser === null || browser === void 0 ? void 0 : (ref = browser.platform) === null || ref === void 0 ? void 0 : ref.type) === "mobile" && (browser === null || browser === void 0 ? void 0 : (ref3 = browser.os) === null || ref3 === void 0 ? void 0 : ref3.name) === "Android";
};
var isFirefox = function() {
    var ref;
    var browser = Bowser.parse(navigator.userAgent);
    return (browser === null || browser === void 0 ? void 0 : (ref = browser.browser) === null || ref === void 0 ? void 0 : ref.name) === "Firefox";
};
var isIOSMobile = function() {
    var ref;
    var browser = bowser__WEBPACK_IMPORTED_MODULE_0___default().parse(navigator.userAgent);
    return ((ref = browser.platform) === null || ref === void 0 ? void 0 : ref.vendor) === "Apple" && navigator.maxTouchPoints > 0 && typeof TouchEvent !== "undefined";
};
var isSafari = function() {
    var minVersion = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, maxVersion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    var ref, ref4, ref5, ref6;
    var browser = bowser__WEBPACK_IMPORTED_MODULE_0___default().parse(navigator.userAgent);
    var ref7;
    /**
   * Safari stopped reporting its version when running in a WebView on iOS15 an above.
   * In this case we can fallback to the OS version, since Safari on iOS
   * _usually_ matches the OS version anyway (not necessarily the patch version).
   * This avoids trying to destructure from undefined, which would result in a client exception.
   * See https://github.com/lancedikson/bowser/issues/499
   */ var version = (ref7 = browser === null || browser === void 0 ? void 0 : (ref = browser.browser) === null || ref === void 0 ? void 0 : ref.version) !== null && ref7 !== void 0 ? ref7 : browser === null || browser === void 0 ? void 0 : (ref4 = browser.os) === null || ref4 === void 0 ? void 0 : ref4.version;
    var ref8 = _slicedToArray(version === null || version === void 0 ? void 0 : version.split(".").map(function(n) {
        return parseInt(n, 10);
    }), 1), major = ref8[0];
    if (!major) return (browser === null || browser === void 0 ? void 0 : (ref5 = browser.browser) === null || ref5 === void 0 ? void 0 : ref5.name) === "Safari";
    return (browser === null || browser === void 0 ? void 0 : (ref6 = browser.browser) === null || ref6 === void 0 ? void 0 : ref6.name) === "Safari" && major >= minVersion && major <= maxVersion;
};


/***/ }),

/***/ 1975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ cloneParticipantAndMungeForIframeProvider; },
/* harmony export */   "$T": function() { return /* binding */ isTrackOff; },
/* harmony export */   "FD": function() { return /* binding */ isParticipantTrackOff; },
/* harmony export */   "_k": function() { return /* binding */ cloneParticipantsAndMungeForIframeProvider; }
/* harmony export */ });
/* harmony import */ var _userData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4218);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

// This function massages the participant object to remove the MediaStreamTracks
// and manipulate userData to match the client set userData (which internally
// is nested under CUSTOMER_USER_DATA_KEY ('c') so as not to interfere with prebuilt's
// usage) Note: doesn't actually delete the tracks fields, just marks them undefined,
// for code simplicity.
function cloneParticipantAndMungeForIframeProvider(participant) {
    var participantClone = _objectSpread({}, participant, {
        audioTrack: undefined,
        videoTrack: undefined,
        screenVideoTrack: undefined,
        screenAudioTrack: undefined,
        tracks: {
            audio: _objectSpread({}, participant.tracks.audio, {
                track: undefined,
                persistentTrack: undefined
            }),
            video: _objectSpread({}, participant.tracks.video, {
                track: undefined,
                persistentTrack: undefined
            }),
            screenAudio: _objectSpread({}, participant.tracks.screenAudio, {
                track: undefined,
                persistentTrack: undefined
            }),
            screenVideo: _objectSpread({}, participant.tracks.screenVideo, {
                track: undefined,
                persistentTrack: undefined
            })
        }
    });
    if (participant.userData !== undefined) {
        // The spec says that `userData` is not in the participants object if it is undefined
        if (participant.userData[_userData__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_USER_DATA_KEY */ .Ly] === undefined) {
            delete participantClone.userData;
        } else {
            participantClone.userData = participant.userData[_userData__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_USER_DATA_KEY */ .Ly];
        }
    }
    return participantClone;
}
function cloneParticipantsAndMungeForIframeProvider(participants) {
    var newParticipants = {};
    for(var id in participants){
        newParticipants[id] = cloneParticipantAndMungeForIframeProvider(participants[id]);
    }
    return newParticipants;
}
/**
 * Determines whether a track is considered as off.
 * @param p The participant object to check.
 * @param type The track type. Must match a key of a participant's 'tracks' object.
 * @returns true in case the track is in a 'blocked' or 'off' state.
 */ function isParticipantTrackOff(p, type) {
    var trackState = p === null || p === void 0 ? void 0 : p.tracks[type];
    if (!trackState) return true;
    return trackState.state === "blocked" || trackState.state === "off";
}
function isTrackOff(trackState) {
    return trackState === "blocked" || trackState === "off";
}


/***/ }),

/***/ 5184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getQueryParam; }
/* harmony export */ });
var getQueryParam = function(key, query) {
    return Array.isArray(query === null || query === void 0 ? void 0 : query[key]) ? query[key][0] : query[key];
};


/***/ }),

/***/ 7556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C$": function() { return /* binding */ useShowMobilePageMenu; },
/* harmony export */   "DE": function() { return /* binding */ useShowMobileMoreMenu; },
/* harmony export */   "Sg": function() { return /* binding */ usePinnedId; },
/* harmony export */   "UX": function() { return /* binding */ useMobileTray; },
/* harmony export */   "Ut": function() { return /* binding */ usePreferredViewMode; },
/* harmony export */   "mJ": function() { return /* binding */ useViewMode; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var _features_breakouts_hooks_useBreakoutSessionState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1925);
/* harmony import */ var _hooks_useCustomIntegrations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(468);
/* harmony import */ var _hooks_useScreens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2275);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8890);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





/**
 * This file contains UI state pertaining to layout. E.g.: are we on a mobile device or not,
 * which view mode is preferred.
 */ var mobileTrayState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "mobile-tray",
    default: true
});
/**
 * Returns whether the mobile tray should be shown and a setter to change it.
 */ var useMobileTray = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(mobileTrayState);
};
var showMobileMoreMenuState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "show-mobile-more-menu-state",
    default: false
});
/**
 * Returns a flag indicating whether to show the More menu in mobile view.
 */ var useShowMobileMoreMenu = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(showMobileMoreMenuState);
};
var showMobilePageMenuState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "show-mobile-page-menu-state",
    default: false
});
/**
 * Returns a flag indicating whether to show the page menu in mobile view.
 */ var useShowMobilePageMenu = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(showMobilePageMenuState);
};
var pinnedIdState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "pinned-id",
    default: null
});
/**
 * Returns the currently pinned session or screen id and a setter to change it.
 */ var usePinnedId = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(pinnedIdState);
};
var preferredViewModeState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "preferred-view-mode",
    default: new Promise(function(resolve) {
        if (false) {}
        var search = new URLSearchParams(window.location.search);
        if (search.get("v") === "grid") {
            resolve("grid");
            return;
        }
        resolve("speaker");
        return;
    })
});
/**
 * Returns the currently preferred view mode and a setter to change it.
 */ var usePreferredViewMode = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(preferredViewModeState);
};
var viewModeSelector = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZ)({
    key: "view-mode",
    get: function(param) {
        var get = param.get;
        var isMobile = get(_core__WEBPACK_IMPORTED_MODULE_4__/* .isMobileState */ .lo);
        if (isMobile) return "mobile";
        var pinnedId = get(pinnedIdState);
        if (pinnedId) return "speaker";
        var preferredViewMode = get(preferredViewModeState);
        return preferredViewMode;
    }
});
/**
 * Returns the current view mode: 'grid', 'speaker' or 'mobile'.
 * In case a participant or screen is pinned or a screen is shared, it will default to 'speaker'.
 */ var useViewMode = function() {
    var screens = (0,_hooks_useScreens__WEBPACK_IMPORTED_MODULE_3__/* .useScreens */ .O)();
    var viewMode = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilValue */ .sJ)(viewModeSelector);
    var breakoutStatus = (0,_features_breakouts_hooks_useBreakoutSessionState__WEBPACK_IMPORTED_MODULE_1__/* .useBreakoutSessionState */ .V)().breakoutStatus;
    var ref = _slicedToArray(usePinnedId(), 1), pinnedId = ref[0];
    var runningMainIntegrations = (0,_hooks_useCustomIntegrations__WEBPACK_IMPORTED_MODULE_2__/* .useCustomIntegrations */ .J)().runningMainIntegrations;
    if (screens.length + runningMainIntegrations.length > 0 && viewMode !== "mobile" || pinnedId) return "speaker";
    if (breakoutStatus === "ongoing") return "grid";
    return viewMode;
};


/***/ }),

/***/ 5328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ useAutoplayFailedModal; },
/* harmony export */   "$n": function() { return /* binding */ useSettingsView; },
/* harmony export */   "Dc": function() { return /* binding */ useMuteAllModal; },
/* harmony export */   "IA": function() { return /* binding */ useDeviceInUseModal; },
/* harmony export */   "Kg": function() { return /* binding */ useScreenshareErrorModal; },
/* harmony export */   "OB": function() { return /* binding */ useUnblockPermissionsModal; },
/* harmony export */   "YH": function() { return /* binding */ useDeviceNotFoundModal; },
/* harmony export */   "__": function() { return /* binding */ useNameModal; },
/* harmony export */   "m$": function() { return /* binding */ useStartScreenshareModal; },
/* harmony export */   "qu": function() { return /* binding */ useAppsModal; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);

var settingsViewState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "settings-view",
    default: null
});
/**
 * Used to control visibility and tabs for SettingsModal.
 */ var useSettingsView = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(settingsViewState);
};
var autoplayFailedModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "autoplay-failed-modal",
    default: false
});
/**
 * Used to control visibility of AutoPlayFailedModal.
 */ var useAutoplayFailedModal = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(autoplayFailedModalState);
};
var deviceInUseModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "device-in-use-modal",
    default: false
});
/**
 * Used to control visibility of DeviceInUseModal.
 */ var useDeviceInUseModal = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(deviceInUseModalState);
};
var deviceNotFoundModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "device-not-found-modal",
    default: false
});
/**
 * Used to control visibility of DeviceNotFoundModal.
 */ var useDeviceNotFoundModal = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(deviceNotFoundModalState);
};
var nameModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "name-modal-state",
    default: false
});
/**
 * Used to control visibility of NameModal.
 */ var useNameModal = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(nameModalState);
};
var startScreenshareModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "start-screenshare-modal-state",
    default: false
});
/**
 * Used to control visibility of StartScreenshareModal.
 */ var useStartScreenshareModal = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(startScreenshareModalState);
};
var screenshareErrorModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "screenshare-error-modal-state",
    default: null
});
/**
 * Used to control visibility of ScreenshareErrorModal.
 */ var useScreenshareErrorModal = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(screenshareErrorModalState);
};
var unblockPermissionsModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "unblock-modal-state",
    default: false
});
/**
 * Used to control visibility of UnblockPermissionsModal.
 */ var useUnblockPermissionsModal = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(unblockPermissionsModalState);
};
var muteAllModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "mute-all-modal-state",
    default: false
});
/**
 * Used to control visibility of MuteAllModal.
 */ var useMuteAllModal = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(muteAllModalState);
};
var appsModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "apps-modal-state",
    default: false
});
/**
 * Used to control visibility of AppsModal.
 */ var useAppsModal = function() {
    return (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .useRecoilState */ .FV)(appsModalState);
};


/***/ }),

/***/ 4218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ly": function() { return /* binding */ CUSTOMER_USER_DATA_KEY; },
/* harmony export */   "T3": function() { return /* binding */ setPrebuiltUserData; },
/* harmony export */   "Ui": function() { return /* binding */ PREBUILT_USER_DATA_KEY; },
/* harmony export */   "n1": function() { return /* binding */ getPrebuiltUserData; }
/* harmony export */ });
/* unused harmony export getIframeUserData */
/* harmony import */ var _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

// This file includes helper functions for working with userData
// and ensuring that prebuilt usage doesn't stomp or get confused
// with iframe usage. Instead of using daily-js setUserData or
// accessing userData directly from the participant blobs, prebuilt
// should use `setPrebuiltUserData` and `getPrebuiltUserData` defined
// below
var CUSTOMER_USER_DATA_KEY = "c";
var PREBUILT_USER_DATA_KEY = "p";
var setPrebuiltUserData = function() {
    var _ref = _asyncToGenerator(_home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(daily, data) {
        var iframeUserData, newData;
        return _home_runner_work_pluot_core_pluot_core_north_star_packages_call_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    iframeUserData = getIframeUserData(daily);
                    if (!(iframeUserData === undefined && data === undefined)) {
                        _ctx.next = 5;
                        break;
                    }
                    _ctx.next = 4;
                    return daily.setUserData(data);
                case 4:
                    return _ctx.abrupt("return", _ctx.sent);
                case 5:
                    newData = _defineProperty({}, PREBUILT_USER_DATA_KEY, data);
                    if (iframeUserData !== undefined) {
                        newData[CUSTOMER_USER_DATA_KEY] = iframeUserData;
                    }
                    _ctx.next = 9;
                    return daily.setUserData(newData);
                case 9:
                    return _ctx.abrupt("return", _ctx.sent);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function setPrebuiltUserData(daily, data) {
        return _ref.apply(this, arguments);
    };
}();
var getPrebuiltUserData = function(daily) {
    var participantId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "local";
    var ref;
    var ref1;
    var participants = (ref1 = daily === null || daily === void 0 ? void 0 : daily.participants()) !== null && ref1 !== void 0 ? ref1 : {};
    if (typeof ((ref = participants[participantId]) === null || ref === void 0 ? void 0 : ref.userData) !== "object") {
        var ref2;
        // in prebuilt, userData should always be either an object of
        // the form { i?: <something>, p?: <something } or undefined
        // if it is anything else, it means that prebuilt has called
        // daily-js.setUserData directly without the setPrebuiltUserData
        // helper above. let's detect this to help prevent that mistake.
        if (((ref2 = participants[participantId]) === null || ref2 === void 0 ? void 0 : ref2.userData) !== undefined) {
            console.warn("Unsafe use of setUserData detected in prebuilt.");
        }
        return undefined;
    }
    var userData = participants[participantId].userData;
    return _objectSpread({}, userData[PREBUILT_USER_DATA_KEY]);
};
var getIframeUserData = function(daily) {
    var participantId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "local";
    var ref;
    var ref3;
    var participants = (ref3 = daily === null || daily === void 0 ? void 0 : daily.participants()) !== null && ref3 !== void 0 ? ref3 : {};
    if (typeof ((ref = participants[participantId]) === null || ref === void 0 ? void 0 : ref.userData) !== "object") {
        var ref4;
        // unlike in prebuilt code, for customer use of useData, we
        // actually shim the call and can guarantee that the data the
        // sent is either nested in an object or undefined, nonetheless
        // let's warn prebuilt if it's done something to muck with it
        // like we do in getPrebuiltUserData :)
        if (((ref4 = participants[participantId]) === null || ref4 === void 0 ? void 0 : ref4.userData) !== undefined) {
            console.warn("Unsafe use of setUserData detected in prebuilt.");
        }
        return undefined;
    }
    var userData = participants[participantId].userData;
    return userData[CUSTOMER_USER_DATA_KEY];
};


/***/ }),

/***/ 2284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CallUI; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ../shared/dist/contexts/Snackbar/index.js
var Snackbar = __webpack_require__(4017);
// EXTERNAL MODULE: ../shared/dist/lib/safeStorage.js
var safeStorage = __webpack_require__(9930);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(2642);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.esm.js
var react_error_boundary_esm = __webpack_require__(4511);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(2031);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../shared/dist/components/Button/index.js
var Button = __webpack_require__(9757);
// EXTERNAL MODULE: ../shared/dist/components/Icons/CamIcon.js
var CamIcon = __webpack_require__(9430);
// EXTERNAL MODULE: ../shared/dist/components/Icons/CloseIcon.js
var CloseIcon = __webpack_require__(7880);
// EXTERNAL MODULE: ../shared/dist/components/Icons/MicrophoneIcon.js
var MicrophoneIcon = __webpack_require__(7711);
// EXTERNAL MODULE: ../shared/dist/components/Text/index.js
var Text = __webpack_require__(5645);
// EXTERNAL MODULE: ../shared/dist/contexts/Theme/index.js
var Theme = __webpack_require__(1609);
// EXTERNAL MODULE: ../daily-react/dist/daily-react.esm.js + 1 modules
var daily_react_esm = __webpack_require__(4283);
// EXTERNAL MODULE: ../../node_modules/bowser/es5.js
var es5 = __webpack_require__(7160);
var es5_default = /*#__PURE__*/__webpack_require__.n(es5);
// EXTERNAL MODULE: ./components/ChunkLoader/index.ts + 1 modules
var ChunkLoader = __webpack_require__(2709);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(9547);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ../shared/dist/components/Card/index.js
var Card = __webpack_require__(8257);
// EXTERNAL MODULE: ../shared/dist/components/LoadingSpinner/index.js
var LoadingSpinner = __webpack_require__(3102);
// EXTERNAL MODULE: ../shared/dist/components/Stack/index.js
var Stack = __webpack_require__(4776);
// EXTERNAL MODULE: ./hooks/useStyleVariants.ts
var useStyleVariants = __webpack_require__(6803);
// EXTERNAL MODULE: ./components/PoweredByDailyBanner/index.ts + 1 modules
var PoweredByDailyBanner = __webpack_require__(7532);
// EXTERNAL MODULE: ./hooks/useCallConfig.ts
var useCallConfig = __webpack_require__(6081);
;// CONCATENATED MODULE: ./components/WaitingForHost/WaitingForHost.tsx












var WaitingForHost = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var textVariant = (0,useStyleVariants/* useStyleVariants */._)().textVariant;
    var ref = (0,Theme.useTheme)(), mediaQueries = ref.mediaQueries, zIndex = ref.zIndex;
    var ref1 = (0,react.useState)(false), /*#__PURE__*/ showText = ref1[0], setShowText = ref1[1];
    var poweredByDaily = (0,useCallConfig/* useCallConfig */.A)().poweredByDaily;
    /**
     * This waiting message only shows if there is no owner/host present.
     * Add a delay to avoid the message flashing before the participant
     * count has updated correctly.
     */ (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            setShowText(true);
        }, 300);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styled_jsx_default().dynamic([
            [
                "5862eee67471fd40",
                [
                    mediaQueries.nonCoarse,
                    zIndex.header
                ]
            ]
        ]) + " " + "container",
        children: [
            poweredByDaily && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "5862eee67471fd40",
                        [
                            mediaQueries.nonCoarse,
                            zIndex.header
                        ]
                    ]
                ]) + " " + "banner",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweredByDailyBanner/* PoweredByDailyBanner */.D, {})
            }),
            showText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "5862eee67471fd40",
                        [
                            mediaQueries.nonCoarse,
                            zIndex.header
                        ]
                    ]
                ]) + " " + "waitingForHost",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner.LoadingSpinner, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        variant: "largestrong",
                                        children: t("broadcast.waitingForHostTitle")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                        textAlign: "center",
                                        variant: textVariant,
                                        children: t("broadcast.waitingForHostSubtitle")
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "5862eee67471fd40",
                dynamic: [
                    mediaQueries.nonCoarse,
                    zIndex.header
                ],
                children: ".container.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;overflow:auto;padding:46px 16px 16px;width:100%}.waitingForHost.__jsx-style-dynamic-selector{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;width:100%;padding:8px}.waitingForHost.__jsx-style-dynamic-selector .card-content{padding:32px}@media ".concat(mediaQueries.nonCoarse, "{.haircheck.__jsx-style-dynamic-selector>*:not(.banner){margin:auto}}.banner.__jsx-style-dynamic-selector{-webkit-box-flex:0;-webkit-flex:none;-moz-box-flex:0;-ms-flex:none;flex:none;left:0;position:fixed;top:0;width:100vw;z-index:").concat(zIndex.header, "}")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/WaitingForHost/index.ts


// EXTERNAL MODULE: ./contexts/CallProvider.tsx + 1 modules
var CallProvider = __webpack_require__(6797);
// EXTERNAL MODULE: ./features/waiting-room/contexts/WaitingRoomProvider.tsx
var WaitingRoomProvider = __webpack_require__(5398);
// EXTERNAL MODULE: ./hooks/useAudioProcessor.ts
var useAudioProcessor = __webpack_require__(8152);
// EXTERNAL MODULE: ./hooks/useBackgroundEffect.ts
var useBackgroundEffect = __webpack_require__(416);
;// CONCATENATED MODULE: ./lib/getIntendedQuality.ts
function getIntendedQuality(param) {
    var camMuteDisabled = param.camMuteDisabled, isSharingScreen = param.isSharingScreen, networkThreshold = param.networkThreshold, qualitySetting = param.qualitySetting;
    // In very bad network conditions, we'll disregard the user's qualitySetting preferences.
    if (networkThreshold === "very-low" || qualitySetting === "bandwidth-saver") {
        return camMuteDisabled ? "low" : "bandwidth-saver";
    }
    // set quality to low or bandwidth saver when: the network conditions are bad, the user selected it, or when they are screen sharing.
    if (networkThreshold === "low" || qualitySetting === "low" || isSharingScreen) {
        return "low";
    }
    if (networkThreshold === "good" && !isSharingScreen) {
        return qualitySetting;
    }
}

// EXTERNAL MODULE: ./hooks/useVideoQuality.tsx
var useVideoQuality = __webpack_require__(5192);
;// CONCATENATED MODULE: ./hooks/useBandwidthControls.ts




var STANDARD_HIGH_BITRATE_CAP = 980;
var STANDARD_LOW_BITRATE_CAP = 300;
/**
 * Automatically updates bandwidth controls based on topology, network threshold and videoQuality.
 */ var useBandwidthControls = function() {
    var videoQuality = (0,useVideoQuality/* useVideoQuality */.y)().videoQuality;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    var meetingState = (0,daily_react_esm/* useMeetingState */.H7)();
    var ref = (0,daily_react_esm/* useNetwork */.LN)(), threshold = ref.threshold, topology = ref.topology;
    var isSharingScreen = (0,daily_react_esm/* useScreenShare */.N2)().isSharingScreen;
    var lastQualitySet = (0,react.useRef)(null);
    var lastSetKBS = (0,react.useRef)(null);
    var remotePeers = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: "remote"
    });
    /**
   * Query param based flag to turn off auto-cam-mute on very-low network.
   */ var disableCameraNetworkQualityMute = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        var query = new URLSearchParams(window.location.search);
        disableCameraNetworkQualityMute.current = query.has("disableCameraNetworkQualityMute");
    }, []);
    var setQuality = (0,react.useCallback)(function(q) {
        if (!daily || daily.isDestroyed()) return;
        if ([
            "new",
            "loading"
        ].includes(meetingState) || !topology) return;
        var peers = remotePeers.length;
        var isSFU = topology === "sfu";
        var lowKbs = isSFU ? STANDARD_LOW_BITRATE_CAP : Math.floor(STANDARD_LOW_BITRATE_CAP / Math.max(1, peers));
        var highKbs = isSFU ? STANDARD_HIGH_BITRATE_CAP : Math.floor(STANDARD_HIGH_BITRATE_CAP / Math.max(1, peers));
        switch(q){
            case "auto":
            case "high":
                if (lastSetKBS.current !== highKbs) {
                    daily.setBandwidth({
                        kbs: highKbs
                    });
                    lastSetKBS.current = highKbs;
                }
                break;
            case "low":
                if (lastSetKBS.current !== lowKbs) {
                    daily.setBandwidth({
                        kbs: lowKbs
                    });
                    lastSetKBS.current = lowKbs;
                }
                break;
            case "bandwidth-saver":
                daily.setLocalVideo(false);
                if (lastSetKBS.current !== lowKbs) {
                    daily.setBandwidth({
                        kbs: lowKbs
                    });
                    lastSetKBS.current = lowKbs;
                }
                break;
        }
        lastQualitySet.current = q;
    }, [
        daily,
        meetingState,
        remotePeers,
        topology
    ]);
    /**
   * Re-calculate bandwidth limits when network threshold or videoQuality changes.
   */ (0,react.useEffect)(function() {
        var intendedQuality = getIntendedQuality({
            camMuteDisabled: disableCameraNetworkQualityMute.current,
            isSharingScreen: isSharingScreen,
            networkThreshold: threshold,
            qualitySetting: videoQuality
        });
        setQuality(intendedQuality);
    }, [
        isSharingScreen,
        setQuality,
        threshold,
        videoQuality,
        topology
    ]);
};

// EXTERNAL MODULE: ./hooks/useDebugging.ts
var useDebugging = __webpack_require__(2428);
// EXTERNAL MODULE: ./hooks/useSoundLoader.ts + 1 modules
var useSoundLoader = __webpack_require__(6240);
// EXTERNAL MODULE: ./lib/browserConfig.ts
var browserConfig = __webpack_require__(7530);
// EXTERNAL MODULE: ./lib/state/core.ts
var core = __webpack_require__(8890);
// EXTERNAL MODULE: ./components/App/Layout.tsx + 1 modules
var Layout = __webpack_require__(9142);
;// CONCATENATED MODULE: ./components/App/LoadingScreen.tsx




var LoadingScreen = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-4d499f1db3cc8313",
                /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner.LoadingSpinner, {})
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "4d499f1db3cc8313",
                children: "div.jsx-4d499f1db3cc8313{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100vh;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/App/FinalMessage.tsx







var FinalMessage = function(param) {
    var _cta = param.cta, cta = _cta === void 0 ? null : _cta, desc = param.desc, _icon = param.icon, icon = _icon === void 0 ? null : _icon, _poweredByDaily = param.poweredByDaily, poweredByDaily = _poweredByDaily === void 0 ? false : _poweredByDaily, _showLoadingScreen = param.showLoadingScreen, showLoadingScreen = _showLoadingScreen === void 0 ? false : _showLoadingScreen, title = param.title, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    if (showLoadingScreen) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen, {});
    var titleColor = {
        default: "default",
        error: "error",
        success: "success"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            poweredByDaily && /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweredByDailyBanner/* PoweredByDailyBanner */.D, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-a2a29622f42dbbc8" + " " + "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack.Stack, {
                        /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.CardContent, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                    align: "center",
                                    gap: 16,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack.Stack, {
                                            align: "center",
                                            children: [
                                                icon,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                    color: titleColor[variant],
                                                    textAlign: "center",
                                                    variant: "largestrong",
                                                    children: title
                                                }),
                                                desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                                                    textAlign: "center",
                                                    children: desc
                                                })
                                            ]
                                        }),
                                        cta
                                    ]
                                })
                            })
                        })
                    }),
                    (0,jsx_runtime.jsx)((styled_jsx_default()), {
                        id: "a2a29622f42dbbc8",
                        children: ".container.jsx-a2a29622f42dbbc8{-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;overflow:auto;width:100%;padding:8px}.container.jsx-a2a29622f42dbbc8 .card-content{padding:32px}"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./lib/state/custom.ts
var custom = __webpack_require__(3510);
;// CONCATENATED MODULE: ./components/App/useIntercomIntegration.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




/**
 * Helper hook to identify whether this call is running in an Intercom integration.
 * Automatically hides participant bar, names and leave button.
 */ var useIntercomIntegration = function() {
    var query = (0,router.useRouter)().query;
    var state = (0,CallProvider/* useCallState */.oz)().state;
    var ref = _slicedToArray((0,custom/* useShowFullscreenButton */.Ei)(), 2), setShowFullscreenButton = ref[1];
    var ref1 = _slicedToArray((0,custom/* useShowLeaveButton */.Ik)(), 2), setShowLeaveButton = ref1[1];
    var ref2 = _slicedToArray((0,custom/* useShowNames */.zD)(), 2), setShowNames = ref2[1];
    var ref3 = _slicedToArray((0,custom/* useShowParticipantsBar */.Q1)(), 2), setShowParticipantsBar = ref3[1];
    var configureForIntercom = (0,react.useCallback)(function() {
        setShowParticipantsBar(false);
        setShowNames(false);
        setShowLeaveButton(false);
        setShowFullscreenButton(true);
    }, [
        setShowFullscreenButton,
        setShowLeaveButton,
        setShowNames,
        setShowParticipantsBar, 
    ]);
    (0,react.useEffect)(function() {
        if (query["autojoin"] === "t" && query["intercomAppLink"] === "t" && state === "joining") {
            configureForIntercom();
        }
    }, [
        configureForIntercom,
        query,
        state
    ]);
};

;// CONCATENATED MODULE: ./components/App/App.tsx
function App_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function App_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function App_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function App_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function App_slicedToArray(arr, i) {
    return App_arrayWithHoles(arr) || App_iterableToArrayLimit(arr, i) || App_unsupportedIterableToArray(arr, i) || App_nonIterableRest();
}
function App_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return App_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return App_arrayLikeToArray(o, minLen);
}































var Call = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3967), __webpack_require__.e(3765), __webpack_require__.e(6824), __webpack_require__.e(3519), __webpack_require__.e(5017)]).then(__webpack_require__.bind(__webpack_require__, 5017)).then(function(mod) {
        return mod.Call;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5017)
            ];
        }
    },
    loading: ChunkLoader/* AutoChunkLoader */.E
});
var Haircheck = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3967), __webpack_require__.e(3245), __webpack_require__.e(3765), __webpack_require__.e(7877), __webpack_require__.e(6824), __webpack_require__.e(3519), __webpack_require__.e(2998), __webpack_require__.e(4442), __webpack_require__.e(5490)]).then(__webpack_require__.bind(__webpack_require__, 5490)).then(function(mod) {
        return mod.Haircheck;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5490)
            ];
        }
    },
    loading: ChunkLoader/* AutoChunkLoader */.E
});
var MobileView = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3967), __webpack_require__.e(3245), __webpack_require__.e(3765), __webpack_require__.e(7877), __webpack_require__.e(6824), __webpack_require__.e(3519), __webpack_require__.e(2998), __webpack_require__.e(4442)]).then(__webpack_require__.bind(__webpack_require__, 4442)).then(function(mod) {
        return mod.MobileView;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4442)
            ];
        }
    },
    loading: ChunkLoader/* AutoChunkLoader */.E
});
var Tray = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3245), __webpack_require__.e(7877), __webpack_require__.e(6824), __webpack_require__.e(2998), __webpack_require__.e(9969)]).then(__webpack_require__.bind(__webpack_require__, 5703)).then(function(mod) {
        return mod.Tray;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5703)
            ];
        }
    },
    loading: ChunkLoader/* AutoChunkLoader */.E
});
var App = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var colors = (0,Theme.useTheme)().colors;
    var addMessage = (0,Snackbar.useSnackbar)().addMessage;
    var ref8 = (0,CallProvider/* useCallState */.oz)(), mode = ref8.mode, reloadCall = ref8.reloadCall, state = ref8.state;
    var ref1 = (0,useCallConfig/* useCallConfig */.A)(), broadcast = ref1.broadcast, broadcastRole = ref1.broadcastRole;
    var ref2 = (0,daily_react_esm/* useDevices */.Ls)(), camState = ref2.camState, micState = ref2.micState;
    var ref3 = App_slicedToArray((0,core/* useIsMobile */.dD)(), 2), isMobile = ref3[0], setIsMobile = ref3[1];
    var ref4 = (0,react.useState)(false), disableWaitingForHostMsg = ref4[0], setDisableWaitingForHostMsg = ref4[1];
    var ownerParticipantIds = (0,daily_react_esm/* useParticipantIds */.OV)({
        filter: "owner"
    });
    var poweredByDaily = (0,useCallConfig/* useCallConfig */.A)().poweredByDaily;
    var errorSound = (0,useSoundLoader/* useSoundLoader */.Q)().errorSound;
    var ref5 = (0,useDebugging/* useDebugging */.W)(), disablePrebuiltDebugger = ref5.disablePrebuiltDebugger, enablePrebuiltDebugger = ref5.enablePrebuiltDebugger;
    var query = (0,router.useRouter)().query;
    var daily = (0,daily_react_esm/* useDaily */.VI)();
    useBandwidthControls();
    useIntercomIntegration();
    /**
   * Applies stored background effect when the camera is started.
   */ (0,useBackgroundEffect/* useBackgroundEffect */.G)();
    /**
   * Applies stored audio processor when the camera is started
   */ var ref6 = (0,useAudioProcessor/* useAudioProcessor */.p)(), currentAudioProcessor = ref6.currentAudioProcessor, setAudioProcessor = ref6.setAudioProcessor;
    (0,daily_react_esm/* useDailyEvent */.VU)("started-camera", (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, inputSettings;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (daily) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    _ctx.next = 5;
                    return daily.getInputSettings();
                case 5:
                    inputSettings = _ctx.sent;
                    if (currentAudioProcessor && !(inputSettings === null || inputSettings === void 0 ? void 0 : (ref = inputSettings.audio) === null || ref === void 0 ? void 0 : ref.processor)) {
                        setAudioProcessor(currentAudioProcessor);
                    }
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        currentAudioProcessor,
        daily,
        setAudioProcessor
    ]));
    /**
   * Provide debugging functionality
   */ (0,react.useEffect)(function() {
        window["dailyDisablePrebuiltDebugger"] = disablePrebuiltDebugger;
        window["dailyEnablePrebuiltDebugger"] = enablePrebuiltDebugger;
        if ("debug" in query) {
            enablePrebuiltDebugger();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query
    ]);
    /**
   * Listen for live-streaming errors and show a snackbar in case.
   */ (0,daily_react_esm/* useLiveStreaming */.vW)({
        onLiveStreamingError: (0,react.useCallback)(function() {
            addMessage({
                content: t("notification.liveStreamingError"),
                type: "error"
            });
        }, [
            addMessage,
            t
        ])
    });
    /**
   * Determine whether the client runs on mobile.
   * This activates the mobile UI.
   */ (0,react.useEffect)(function() {
        if (isMobile) return;
        var platform = es5_default().parse(window.navigator.userAgent).platform;
        var browserType = platform === null || platform === void 0 ? void 0 : platform.type;
        if ([
            "mobile",
            "tablet"
        ].includes(browserType) || (0,browserConfig/* isIOSMobile */.eS)()) {
            setIsMobile(true);
        }
    }, [
        isMobile,
        setIsMobile
    ]);
    (0,daily_react_esm/* useThrottledDailyEvent */.CH)("participant-joined", (0,react.useCallback)(function(evts) {
        // the "waiting for host" message only shows before a host has joined
        if (evts.some(function(ev) {
            return ev.participant.owner;
        })) setDisableWaitingForHostMsg(true);
    }, []));
    var localSessionId = (0,daily_react_esm/* useLocalSessionId */.q5)();
    var ref7 = App_slicedToArray((0,daily_react_esm/* useParticipantProperty */.ou)(localSessionId, [
        "tracks.audio.off.byRemoteRequest",
        "tracks.video.off.byRemoteRequest", 
    ]), 2), audioMutedByRemoteRequest = ref7[0], videoMutedByRemoteRequest = ref7[1];
    /**
   * Display a muted by host message, in case the participant's mic got muted.
   */ (0,react.useEffect)(function() {
        if (!audioMutedByRemoteRequest) return;
        addMessage({
            content: t("notification.micMutedByHost"),
            type: "info",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MicrophoneIcon/* MicrophoneIcon */.S, {
                muted: true,
                size: 16
            })
        });
    }, [
        addMessage,
        audioMutedByRemoteRequest,
        t
    ]);
    /**
   * Display a muted by host message, in case the participant's cam got muted.
   */ (0,react.useEffect)(function() {
        if (!videoMutedByRemoteRequest) return;
        addMessage({
            content: t("notification.camMutedByHost"),
            type: "info",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CamIcon/* CamIcon */.H, {
                id: "snackbarIcon".concat(Date.now()),
                muted: true,
                size: 16
            })
        });
    }, [
        addMessage,
        videoMutedByRemoteRequest,
        t
    ]);
    /**
   * Play error sound on 'knocking-denied' CallState.
   * TODO: Refactor to 'useEvent' once it's available.
   */ (0,react.useEffect)(function() {
        if (state !== "knocking-denied") return;
        errorSound.play();
    }, [
        errorSound,
        state
    ]);
    var messageProps = (0,react.useMemo)(function() {
        switch(state){
            case "ended":
                return {
                    desc: t("lobby.ended.desc"),
                    title: t("lobby.ended.title"),
                    variant: "error"
                };
            case "error":
                return {
                    desc: t("lobby.error.desc"),
                    title: t("lobby.error.title"),
                    variant: "error"
                };
            case "expired":
                return {
                    desc: t("lobby.expired.desc"),
                    title: t("lobby.expired.title"),
                    variant: "error"
                };
            case "full":
                return {
                    desc: t("lobby.full.desc"),
                    title: t("lobby.full.title"),
                    variant: "error"
                };
            case "joining":
                if ((camState === "pending" || micState === "pending") && broadcast !== null && broadcastRole !== "attendee") {
                    return {
                        desc: t("lobby.devicePermissions.desc"),
                        title: t("lobby.devicePermissions.title")
                    };
                }
                break;
            case "knocking-cancelled":
                return mode === "direct-link" ? {
                    showLoadingScreen: true
                } : {
                    desc: t("lobby.canceled.desc"),
                    title: t("lobby.canceled.title")
                };
            case "knocking-denied":
                return {
                    desc: t("lobby.denied.desc"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon.CloseIcon, {
                        color: colors.system.red
                    }),
                    title: t("lobby.denied.title")
                };
            case "left":
                return {
                    cta: poweredByDaily && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        href: "https://www.daily.co",
                        variant: "secondary",
                        children: t("lobby.left.learnMore")
                    }),
                    desc: poweredByDaily ? t("lobby.left.descBranded") : t("lobby.left.descUnbranded"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text.Text, {
                        variant: "largestrong",
                        children: "\uD83D\uDC4B"
                    }),
                    poweredByDaily: poweredByDaily,
                    title: t("lobby.left.title")
                };
            case "nbf":
                return {
                    cta: mode === "direct-link" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button.Button, {
                        id: "nbf-reload",
                        onClick: reloadCall,
                        variant: "primary",
                        children: t("general.tryAgain")
                    }) : null,
                    desc: t("lobby.notAvailable.desc"),
                    title: t("lobby.notAvailable.title"),
                    variant: "error"
                };
            case "not-allowed":
                return {
                    desc: t("lobby.noAccess.desc"),
                    title: t("lobby.noAccess.title"),
                    variant: "error"
                };
            case "not-found":
                return {
                    desc: t("lobby.notFound.desc"),
                    title: t("lobby.notFound.title"),
                    variant: "error"
                };
            case "not-secure":
                return {
                    desc: t("lobby.notSecure.desc"),
                    title: t("lobby.notSecure.title"),
                    variant: "error"
                };
            case "removed-from-call":
                return {
                    desc: t("lobby.removed.desc"),
                    title: t("lobby.removed.title"),
                    variant: "error"
                };
        }
        return null;
    }, [
        broadcast,
        broadcastRole,
        camState,
        colors.system.red,
        micState,
        mode,
        poweredByDaily,
        reloadCall,
        state,
        t, 
    ]);
    return (0,react.useMemo)(function() {
        if (mode === "embedded" && state === "redirecting") {
            // Don't redirect in embedded mode, just clear out UI
            return null;
        }
        if (messageProps) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FinalMessage, _objectSpread({}, messageProps))
            });
        }
        if ([
            "awaiting-args",
            "ready",
            "joining"
        ].includes(state) || // Wait for localParticipant to be present
        !localSessionId) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen, {});
        }
        if (state === "lobby") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Haircheck, {})
            });
        }
        /**
     * A host must be present for OOB attendees to see the in-call UI.
     * Once attendees have entered the call, this message won't be shown
     * again.
     */ if (broadcastRole === "attendee" && ownerParticipantIds.length === 0 && !disableWaitingForHostMsg) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WaitingForHost, {}),
                    ";"
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WaitingRoomProvider/* WaitingRoomProvider */.z, {
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileView, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Call, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tray, {})
                    ]
                })
            })
        });
    }, [
        broadcastRole,
        disableWaitingForHostMsg,
        isMobile,
        localSessionId,
        messageProps,
        ownerParticipantIds.length,
        state,
        mode, 
    ]);
};

;// CONCATENATED MODULE: ./components/App/index.ts


;// CONCATENATED MODULE: ./components/CustomAppError.tsx





/* Our custom NextJS error page, which should never be shown because it means
 * something is very wrong in our app 😅
 * For example: a component triggers an infinite render loop, or a call to a room
 * returns a 500 response from our servers. This page will _not_ override our custom
 * "room could not be found" error. */ function CustomAppError() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-2f1d9447b4380aee" + " " + "error-page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FinalMessage, {
                title: t("lobby.error.title"),
                desc: t("lobby.error.desc"),
                variant: "error"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "2f1d9447b4380aee",
                children: ".error-page.jsx-2f1d9447b4380aee{height:100vh;width:100%;max-width:65ch;margin:0 auto}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./contexts/ConditionalProvider.tsx


var ConditionalProvider = function(param) {
    var check = param.check, children = param.children, Provider = param.Provider;
    var config = (0,useCallConfig/* useCallConfig */.A)();
    if (check(config)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};

// EXTERNAL MODULE: ./contexts/IframeDriverProvider.tsx + 5 modules
var IframeDriverProvider = __webpack_require__(1967);
// EXTERNAL MODULE: ./contexts/MediaDeviceProvider.tsx
var MediaDeviceProvider = __webpack_require__(269);
// EXTERNAL MODULE: ./contexts/ParticipantsProvider.tsx
var ParticipantsProvider = __webpack_require__(9394);
// EXTERNAL MODULE: ./contexts/TracksProvider.tsx
var TracksProvider = __webpack_require__(9815);
// EXTERNAL MODULE: ./lib/query.ts
var lib_query = __webpack_require__(5184);
;// CONCATENATED MODULE: ./pages/[...room].tsx
/* provided dependency */ var process = __webpack_require__(4406);
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
























var BreakoutsProvider = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3245), __webpack_require__.e(4869)]).then(__webpack_require__.bind(__webpack_require__, 3245)).then(function(mod) {
        return mod.BreakoutsProvider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3245)
            ];
        }
    },
    loading: ChunkLoader/* AutoChunkLoader */.E
});
var ChatProvider = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7877), __webpack_require__.e(1673)]).then(__webpack_require__.bind(__webpack_require__, 7877)).then(function(mod) {
        return mod.ChatProvider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7877)
            ];
        }
    },
    loading: ChunkLoader/* AutoChunkLoader */.E
});
var RecordingProvider = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3017).then(__webpack_require__.bind(__webpack_require__, 3017)).then(function(mod) {
        return mod.RecordingProvider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3017)
            ];
        }
    },
    loading: ChunkLoader/* AutoChunkLoader */.E
});
function CallUI(param) {
    var _micAudioMode = param.micAudioMode, micAudioMode = _micAudioMode === void 0 ? "speech" : _micAudioMode;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref13 = (0,router.useRouter)(), query = ref13.query, replace = ref13.replace;
    var ref1 = (0,react.useState)(null), domain = ref1[0], setDomain = ref1[1];
    var ref2 = (0,react.useState)(true), isDomainSet = ref2[0], setIsDomainSet = ref2[1];
    var ref3 = (0,react.useState)(null), customHost = ref3[0], setCustomHost = ref3[1];
    var ref4 = (0,react.useState)(false), bypassRegionDetection = ref4[0], setBypassRegionDetection = ref4[1];
    var ref5 = (0,react.useState)(null), v2CamAndMic = ref5[0], setV2CamAndMic = ref5[1];
    var ref6 = (0,react.useState)(null), useLegacyVideoProcessor = ref6[0], setUseLegacyVideoProcessor = ref6[1];
    var ref7 = (0,react.useState)(null), roomsCheckOrigin = ref7[0], setRoomsCheckOrigin = ref7[1];
    var ref8 = (0,react.useState)(null), apiHost = ref8[0], setApiHost = ref8[1];
    var ref9 = (0,react.useState)(null), room = ref9[0], setRoom = ref9[1];
    var ref10 = (0,react.useState)(""), token = ref10[0], setToken = ref10[1];
    var ref11 = (0,react.useState)(""), frameId = ref11[0], setFrameId = ref11[1];
    /**
   * Read all required query params, once query is ready,
   * making sure they'll never be removed from state,
   * when they're removed from the URL (like token).
   */ (0,react.useEffect)(function() {
        if (Object.keys(query).length === 0) return;
        if (query.debug) {
            var _NEXT_PUBLIC_SENTRY_ENVIRONMENT;
            console.log({
                app_name: "prebuilt",
                git_hash: "07cf1dd337801a66ca1fd1f0b94b0327c6291d92",
                git_ref: "refs/heads/main",
                environment_name: (_NEXT_PUBLIC_SENTRY_ENVIRONMENT = "prod") !== null && _NEXT_PUBLIC_SENTRY_ENVIRONMENT !== void 0 ? _NEXT_PUBLIC_SENTRY_ENVIRONMENT : location.hostname.includes("localhost") || location.hostname.includes("khk-local.wss.daily.co") ? "local-development" : "production"
            });
        }
        if (query.name) {
            // HACK: Set PLUOT_PARTICIPANT_NAME in localStorage directly,
            // so daily-js will pick that up immediately.
            // This has the advantage of not having to wait until daily-js is loaded.
            var safeLocalStorage = (0,safeStorage/* safeStorage */.w)(function() {
                return localStorage;
            });
            safeLocalStorage.setItem("PLUOT_PARTICIPANT_NAME", (0,lib_query/* getQueryParam */.P)("name", query));
        }
        if (query.customHost) {
            setCustomHost((0,lib_query/* getQueryParam */.P)("customHost", query));
        } else if (process.env.DAILY_CUSTOM_HOST) {
            setCustomHost(process.env.DAILY_CUSTOM_HOST);
        }
        if (query.bypassRegionDetection) setBypassRegionDetection((0,lib_query/* getQueryParam */.P)("bypassRegionDetection", query) === "true");
        if (query.v2CamAndMic) {
            var v2CamAndMicParam = (0,lib_query/* getQueryParam */.P)("v2CamAndMic", query);
            var v2CamAndMicParamAsNumber = parseFloat(v2CamAndMicParam);
            setV2CamAndMic(isNaN(v2CamAndMicParamAsNumber) ? v2CamAndMicParam === "true" : v2CamAndMicParamAsNumber);
        }
        if (query.useLegacyVideoProcessor) {
            var _$param = (0,lib_query/* getQueryParam */.P)("useLegacyVideoProcessor", query);
            if (_$param === "true") {
                setUseLegacyVideoProcessor(true);
            } else if (_$param === "false") {
                setUseLegacyVideoProcessor(false);
            }
        }
        if (query.roomsCheckOrigin) {
            setRoomsCheckOrigin((0,lib_query/* getQueryParam */.P)("roomsCheckOrigin", query));
        } else if (process.env.DAILY_ROOMS_CHECK_ORIGIN) {
            setRoomsCheckOrigin(process.env.DAILY_ROOMS_CHECK_ORIGIN);
        }
        if (query.apiHost) {
            setApiHost((0,lib_query/* getQueryParam */.P)("apiHost", query));
        } else if (process.env.DAILY_API_HOST) {
            setApiHost(process.env.DAILY_API_HOST);
        }
        if (query.t) {
            setToken((0,lib_query/* getQueryParam */.P)("t", query));
        }
        if (query.emb) {
            setFrameId((0,lib_query/* getQueryParam */.P)("emb", query));
        }
        if (query.room) {
            if (Array.isArray(query.room)) {
                var ref, ref12;
                var l = query.room.length;
                var r = (ref = query.room) === null || ref === void 0 ? void 0 : ref[l - 1];
                var d = (ref12 = query.room) === null || ref12 === void 0 ? void 0 : ref12[l - 2];
                setRoom(r);
                if (d === null || d === void 0 ? void 0 : d.match(/.+\.daily\.co$/)) {
                    setDomain(d.replace(".daily.co", ""));
                    setIsDomainSet(true);
                    return;
                }
            } else {
                setRoom(query.room);
            }
        }
        if (query.domain) {
            setDomain((0,lib_query/* getQueryParam */.P)("domain", query));
            setIsDomainSet(true);
            return;
        }
        // Find domain via location.hostname
        var dnsTrailer = ".daily.co";
        if (process.env.DAILY_DNS_TRAILER) {
            dnsTrailer = process.env.DAILY_DNS_TRAILER;
        }
        if (location.hostname.endsWith(dnsTrailer)) {
            setDomain(location.hostname.replace(dnsTrailer, ""));
            setIsDomainSet(true);
            return;
        }
        setIsDomainSet(false);
    }, [
        query
    ]);
    /**
   * Once we got the token, remove it from the URL.
   */ (0,react.useEffect)(function() {
        if (!token || !query.t) return;
        var _t = query.t, newQuery = _objectWithoutProperties(query, [
            "t"
        ]);
        replace({
            query: newQuery
        }, undefined, {
            shallow: true
        });
    }, [
        query,
        replace,
        token
    ]);
    var isEmbedded = (0,react.useMemo)(function() {
        return !!frameId;
    }, [
        frameId
    ]);
    if (!isDomainSet) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* RecoilRoot */.Wh, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FinalMessage, {
                    title: t("lobby.notFound.title"),
                    desc: t("lobby.notFound.desc"),
                    variant: "error"
                })
            })
        });
    }
    if (!domain) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* RecoilRoot */.Wh, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen, {})
        });
    }
    var logAppError = function(error) {
        // override the sampling rate via startTransaction(), since we always want to send client-side app errors to Sentry
        var transaction = esm_exports/* startTransaction */.Yr({
            name: "app-error",
            op: "logAppError",
            sampled: true
        });
        (0,esm_exports/* captureException */.Tb)(error);
        transaction === null || transaction === void 0 ? void 0 : transaction.finish();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_error_boundary_esm/* ErrorBoundary */.SV, {
        onError: logAppError,
        FallbackComponent: CustomAppError,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* RecoilRoot */.Wh, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar.SnackbarProvider, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallProvider/* CallProvider */.DG, {
                    domain: domain,
                    room: room,
                    customHost: customHost,
                    token: token,
                    isEmbedded: isEmbedded,
                    bypassRegionDetection: bypassRegionDetection,
                    v2CamAndMic: v2CamAndMic,
                    useLegacyVideoProcessor: useLegacyVideoProcessor,
                    roomsCheckOrigin: roomsCheckOrigin,
                    apiHost: apiHost,
                    micAudioMode: micAudioMode,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParticipantsProvider/* ParticipantsProvider */.n5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TracksProvider/* TracksProvider */.z8, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IframeDriverProvider/* IframeDriverProvider */.mL, {
                                frameId: frameId,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaDeviceProvider/* MediaDeviceProvider */.O, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalProvider, {
                                        check: function(config) {
                                            return Boolean(config.enableRecording);
                                        },
                                        Provider: RecordingProvider,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalProvider, {
                                            check: function(config) {
                                                return Boolean(config.enableChat);
                                            },
                                            Provider: ChatProvider,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalProvider, {
                                                check: function(config) {
                                                    return Boolean(config.enableBreakoutRooms);
                                                },
                                                Provider: BreakoutsProvider,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(App, {})
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 3368:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Anchor = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireWildcard(__webpack_require__(7294));

var _dom = __webpack_require__(6912);

var _excluded = ["children", "className", "href", "onClick", "underline"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Anchor = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      onClick = _ref.onClick,
      underline = _ref.underline,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var isExternalHref = href && href.match(/^(https?:)?\/\//);
  var isHashHref = href === null || href === void 0 ? void 0 : href.match(/^#/);
  var targetProps = isExternalHref ? {
    rel: 'noopener',
    target: '_blank'
  } : {};

  var handleClick = function handleClick(ev) {
    if (isHashHref) {
      ev.preventDefault();
      var targetEl = document.getElementById(href.slice(1));

      if (targetEl) {
        (0, _dom.scrollToElement)(targetEl);
      }
    }

    onClick === null || onClick === void 0 ? void 0 : onClick(ev);
  };

  return /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({
    ref: ref,
    href: href,
    onClick: handleClick
  }, targetProps, props, {
    className: "jsx-4048977518" + " " + (props && props.className != null && props.className || targetProps && targetProps.className != null && targetProps.className || (0, _classnames["default"])(className, {
      underline: underline
    }) || "")
  }), children, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "4048977518"
  }, ["a.jsx-4048977518{color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;position:relative;-webkit-text-decoration:none;text-decoration:none;}", "a.underline.jsx-4048977518{-webkit-text-decoration:underline;text-decoration:underline;}", "a.jsx-4048977518:focus-visible{border-radius:2px;outline:2px solid var(--focus-shadow);}"]));
});
exports.Anchor = Anchor;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 757:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "Anchor", ({
  enumerable: true,
  get: function get() {
    return _Anchor.Anchor;
  }
}));

var _Anchor = __webpack_require__(3368);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQW5jaG9yL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IEFuY2hvciB9IGZyb20gJy4vQW5jaG9yJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEifQ==

/***/ }),

/***/ 9430:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.H = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "id", "muted", "transition", "size"];

var CamIcon = function CamIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      id = _ref.id,
      _ref$muted = _ref.muted,
      muted = _ref$muted === void 0 ? false : _ref$muted,
      _ref$transition = _ref.transition,
      transition = _ref$transition === void 0 ? true : _ref$transition,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["1108613548", [color, size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("mask", {
    id: "camIconMask".concat(id),
    className: _style["default"].dynamic([["1108613548", [color, size, size]]])
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24",
    fill: "white",
    className: _style["default"].dynamic([["1108613548", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.87715 19L18.8772 3",
    stroke: "black",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    className: _style["default"].dynamic([["1108613548", [color, size, size]]]) + " " + ((0, _classnames["default"])('strike', {
      muted: muted,
      transition: transition
    }) || "")
  })), /*#__PURE__*/_react["default"].createElement("g", {
    mask: muted ? "url(#camIconMask".concat(id, ")") : undefined,
    className: _style["default"].dynamic([["1108613548", [color, size, size]]])
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5 7.5C3.89543 7.5 3 8.39543 3 9.5V14.5C3 15.6046 3.89543 16.5 5 16.5H13C14.1046 16.5 15 15.6046 15 14.5V9.5C15 8.39543 14.1046 7.5 13 7.5H5Z",
    className: _style["default"].dynamic([["1108613548", [color, size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.5 10.9491C16.5 10.6634 16.6221 10.3914 16.8356 10.2017L19.3356 7.97943C19.9805 7.40618 21 7.86399 21 8.72684V15.2732C21 16.136 19.9805 16.5938 19.3356 16.0206L16.8356 13.7983C16.6221 13.6086 16.5 13.3366 16.5 13.0509V10.9491Z",
    className: _style["default"].dynamic([["1108613548", [color, size, size]]])
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4 20L20 4",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: "1.5",
    className: _style["default"].dynamic([["1108613548", [color, size, size]]]) + " " + ((0, _classnames["default"])('strike', {
      muted: muted,
      transition: transition
    }) || "")
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1108613548",
    dynamic: [color, size, size]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}"), ".strike.__jsx-style-dynamic-selector{-webkit-transform-origin:center;-ms-transform-origin:center;transform-origin:center;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);}", ".strike.transition.__jsx-style-dynamic-selector{-webkit-transition:-webkit-transform 240ms ease;-webkit-transition:transform 240ms ease;transition:transform 240ms ease;}", ".strike.muted.__jsx-style-dynamic-selector{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);}"]));
};

exports.H = CamIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 7880:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CloseIcon = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "rotate", "size", "variant"];

var CloseIcon = function CloseIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$rotate = _ref.rotate,
      rotate = _ref$rotate === void 0 ? 0 : _ref$rotate,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["1296944475", [color, size, size, rotate]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("g", {
    className: _style["default"].dynamic([["1296944475", [color, size, size, rotate]]])
  }, /*#__PURE__*/_react["default"].createElement("line", {
    x1: "6.41",
    y1: "6.41",
    x2: "17.59",
    y2: "17.59",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: variant === 'thick' ? 2 : 1.5,
    className: _style["default"].dynamic([["1296944475", [color, size, size, rotate]]])
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "17.59",
    y1: "6.41",
    x2: "6.41",
    y2: "17.59",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: variant === 'thick' ? 2 : 1.5,
    className: _style["default"].dynamic([["1296944475", [color, size, size, rotate]]])
  })), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1296944475",
    dynamic: [color, size, size, rotate]
  }, ["svg.__jsx-style-dynamic-selector{fill:".concat(color, ";height:").concat(size, "px;width:").concat(size, "px;display:block;}"), "g.__jsx-style-dynamic-selector{-webkit-transform:rotate(".concat(rotate, "deg);-ms-transform:rotate(").concat(rotate, "deg);transform:rotate(").concat(rotate, "deg);-webkit-transform-origin:center;-ms-transform-origin:center;transform-origin:center;}")]));
};

exports.CloseIcon = CloseIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 7711:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4859);

__webpack_unused_export__ = ({
  value: true
});
exports.S = void 0;

var _style = _interopRequireDefault(__webpack_require__(6422));

var _extends2 = _interopRequireDefault(__webpack_require__(8527));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(2220));

var _classnames = _interopRequireDefault(__webpack_require__(2779));

var _react = _interopRequireDefault(__webpack_require__(7294));

var _excluded = ["color", "id", "muted", "size"],
    _excluded2 = ["color", "id", "muted", "size"],
    _excluded3 = ["transition"];

var MicrophoneIconWithTransition = function MicrophoneIconWithTransition(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      id = _ref.id,
      _ref$muted = _ref.muted,
      muted = _ref$muted === void 0 ? false : _ref$muted,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props, {
    className: _style["default"].dynamic([["3470324109", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("defs", {
    className: _style["default"].dynamic([["3470324109", [size, size]]])
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "micIconMask".concat(id),
    className: _style["default"].dynamic([["3470324109", [size, size]]])
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24",
    fill: "white",
    className: _style["default"].dynamic([["3470324109", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.88 19L18.88 3",
    stroke: "black",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    className: _style["default"].dynamic([["3470324109", [size, size]]]) + " " + ((0, _classnames["default"])('strike', {
      muted: muted
    }) || "")
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    mask: muted ? "url(#micIconMask".concat(id, ")") : undefined,
    className: _style["default"].dynamic([["3470324109", [size, size]]])
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: color,
    d: "M12 3C10.3431 3 9 4.34315 9 6V12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V6C15 4.34315 13.6569 3 12 3Z",
    className: _style["default"].dynamic([["3470324109", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: color,
    d: "M7.5 12C7.5 11.5858 7.16421 11.25 6.75 11.25C6.33579 11.25 6 11.5858 6 12C6 13.9175 6.62158 15.4436 7.73826 16.4858C8.67527 17.3603 9.90114 17.8386 11.25 17.9654V20.25C11.25 20.6642 11.5858 21 12 21C12.4142 21 12.75 20.6642 12.75 20.25V17.9654C14.0989 17.8386 15.3247 17.3603 16.2617 16.4858C17.3784 15.4436 18 13.9175 18 12C18 11.5858 17.6642 11.25 17.25 11.25C16.8358 11.25 16.5 11.5858 16.5 12C16.5 13.5825 15.9966 14.6814 15.2383 15.3892C14.4713 16.105 13.3583 16.5 12 16.5C10.6417 16.5 9.52867 16.105 8.76174 15.3892C8.00342 14.6814 7.5 13.5825 7.5 12Z",
    className: _style["default"].dynamic([["3470324109", [size, size]]])
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4 20L20 4",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: "1.5",
    className: _style["default"].dynamic([["3470324109", [size, size]]]) + " " + ((0, _classnames["default"])('strike', {
      muted: muted
    }) || "")
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "3470324109",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}"), ".strike.__jsx-style-dynamic-selector{-webkit-transform-origin:center;-ms-transform-origin:center;transform-origin:center;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);-webkit-transition:-webkit-transform 240ms ease;-webkit-transition:transform 240ms ease;transition:transform 240ms ease;}", ".strike.muted.__jsx-style-dynamic-selector{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);}"]));
};

var MicrophoneIconStatic = function MicrophoneIconStatic(_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'currentColor' : _ref2$color,
      id = _ref2.id,
      _ref2$muted = _ref2.muted,
      muted = _ref2$muted === void 0 ? false : _ref2$muted,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 24 : _ref2$size,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);

  if (muted) {
    return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    }, props, {
      className: _style["default"].dynamic([["2085849465", [size, size]]]) + " " + (props && props.className != null && props.className || "")
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.99996 2C9.06523 2 9.93598 2.83285 9.99659 3.88293L5.99996 7.87956V4C5.99996 2.89543 6.89539 2 7.99996 2Z",
      fill: color,
      className: _style["default"].dynamic([["2085849465", [size, size]]])
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.99996 6.70711L13.6868 3.02022C13.8821 2.82496 13.8821 2.50838 13.6868 2.31311C13.4916 2.11785 13.175 2.11785 12.9797 2.31311L2.31307 12.9798C2.11781 13.175 2.11781 13.4916 2.31307 13.6869C2.50833 13.8821 2.82492 13.8821 3.02018 13.6869L5.46367 11.2434C6.03955 11.667 6.74051 11.9055 7.49996 11.9769V13.5C7.49996 13.7761 7.72382 14 7.99996 14C8.2761 14 8.49996 13.7761 8.49996 13.5V11.9769C9.3992 11.8924 10.2164 11.5736 10.8411 10.9905C11.5856 10.2957 12 9.27833 12 8C12 7.72386 11.7761 7.5 11.5 7.5C11.2238 7.5 11 7.72386 11 8C11 9.05501 10.6643 9.78763 10.1588 10.2595C9.64751 10.7367 8.90551 11 7.99996 11C7.27926 11 6.66216 10.8332 6.18251 10.5246L6.98398 9.72309C7.28173 9.89904 7.62905 10 7.99996 10C9.10453 10 9.99996 9.10457 9.99996 8V6.70711Z",
      fill: color,
      className: _style["default"].dynamic([["2085849465", [size, size]]])
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.07402 8.8055C5.02583 8.56097 4.99996 8.29291 4.99996 8C4.99996 7.72386 4.7761 7.5 4.49996 7.5C4.22382 7.5 3.99996 7.72386 3.99996 8C3.99996 8.59793 4.09062 9.13877 4.26331 9.61621L5.07402 8.8055Z",
      fill: color,
      className: _style["default"].dynamic([["2085849465", [size, size]]])
    }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
      id: "2085849465",
      dynamic: [size, size]
    }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
  }

  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props, {
    className: _style["default"].dynamic([["2022363242", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C6.89543 2 6 2.89543 6 4V8C6 9.10457 6.89543 10 8 10C9.10457 10 10 9.10457 10 8V4C10 2.89543 9.10457 2 8 2ZM5 8C5 7.72386 4.77614 7.5 4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 9.27833 4.41438 10.2957 5.15884 10.9905C5.78352 11.5736 6.60076 11.8924 7.5 11.9769V13.5C7.5 13.7761 7.72386 14 8 14C8.27614 14 8.5 13.7761 8.5 13.5V11.9769C9.39924 11.8924 10.2165 11.5736 10.8412 10.9905C11.5856 10.2957 12 9.27833 12 8C12 7.72386 11.7761 7.5 11.5 7.5C11.2239 7.5 11 7.72386 11 8C11 9.05501 10.6644 9.78763 10.1588 10.2595C9.64755 10.7367 8.90556 11 8 11C7.09444 11 6.35245 10.7367 5.84116 10.2595C5.33562 9.78763 5 9.05501 5 8Z",
    fill: color,
    className: _style["default"].dynamic([["2022363242", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "2022363242",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

var MicrophoneIcon = function MicrophoneIcon(props) {
  if ('transition' in props) {
    var transition = props.transition,
        rest = (0, _objectWithoutProperties2["default"])(props, _excluded3);
    return /*#__PURE__*/_react["default"].createElement(MicrophoneIconWithTransition, rest);
  }

  return /*#__PURE__*/_react["default"].createElement(MicrophoneIconStatic, props);
};

exports.S = MicrophoneIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 3922:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4859);

var _typeof = __webpack_require__(8921);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SnackbarProvider = exports.SnackbarContext = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(5182));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1068));

var _react = _interopRequireWildcard(__webpack_require__(7294));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SnackbarContext = /*#__PURE__*/(0, _react.createContext)({
  addMessage: function addMessage() {},
  messages: [],
  handleHide: function handleHide() {}
});
exports.SnackbarContext = SnackbarContext;
var counter = 0;

var SnackbarProvider = function SnackbarProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      messages = _useState2[0],
      setMessages = _useState2[1];

  var addMessage = (0, _react.useCallback)(function (m) {
    if (!m.type) m.type = 'success';
    setMessages(function (msgs) {
      return [{
        id: ++counter,
        message: m
      }].concat((0, _toConsumableArray2["default"])(msgs));
    });
  }, []);

  var handleHide = function handleHide(hideId) {
    setMessages(function (msgs) {
      return msgs.filter(function (_ref2) {
        var id = _ref2.id;
        return id !== hideId;
      });
    });
  };

  return /*#__PURE__*/_react["default"].createElement(SnackbarContext.Provider, {
    value: {
      addMessage: addMessage,
      messages: messages,
      handleHide: handleHide
    }
  }, children);
};

exports.SnackbarProvider = SnackbarProvider;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 4017:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "SnackbarProvider", ({
  enumerable: true,
  get: function get() {
    return _SnackbarProvider.SnackbarProvider;
  }
}));
Object.defineProperty(exports, "useSnackbar", ({
  enumerable: true,
  get: function get() {
    return _useSnackbar.useSnackbar;
  }
}));

var _SnackbarProvider = __webpack_require__(3922);

var _useSnackbar = __webpack_require__(3241);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbnRleHRzL1NuYWNrYmFyL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IFNuYWNrYmFyUHJvdmlkZXIgfSBmcm9tICcuL1NuYWNrYmFyUHJvdmlkZXInO1xuZXhwb3J0IHsgdXNlU25hY2tiYXIgfSBmcm9tICcuL3VzZVNuYWNrYmFyJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0EifQ==

/***/ }),

/***/ 3241:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useSnackbar = void 0;

var _react = __webpack_require__(7294);

var _SnackbarProvider = __webpack_require__(3922);

var useSnackbar = function useSnackbar() {
  return (0, _react.useContext)(_SnackbarProvider.SnackbarContext);
};

exports.useSnackbar = useSnackbar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTbmFja2JhciIsInVzZUNvbnRleHQiLCJTbmFja2JhckNvbnRleHQiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udGV4dHMvU25hY2tiYXIvdXNlU25hY2tiYXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgU25hY2tiYXJDb250ZXh0LCBTbmFja2JhclByb3ZpZGVyVmFsdWUgfSBmcm9tICcuL1NuYWNrYmFyUHJvdmlkZXInO1xuXG5leHBvcnQgY29uc3QgdXNlU25hY2tiYXIgPSAoKSA9PlxuICB1c2VDb250ZXh0PFNuYWNrYmFyUHJvdmlkZXJWYWx1ZT4oU25hY2tiYXJDb250ZXh0KTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBOztBQUVPLElBQU1BLFdBQVcsR0FBRyxTQUFkQSxXQUFjO0VBQUEsT0FDekIsSUFBQUMsaUJBQUEsRUFBa0NDLGlDQUFsQyxDQUR5QjtBQUFBLENBQXBCIn0=

/***/ }),

/***/ 4605:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useResize = void 0;

var _react = __webpack_require__(7294);

/**
 * Accepts a stable function reference to be called on window.resize
 * and window.orientationchange events.
 * useResize calls the function once initially.
 */
var useResize = function useResize(callback) {
  (0, _react.useEffect)(function () {
    var frame;

    var handleResize = function handleResize() {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        return callback();
      });
    };

    window.addEventListener('resize', handleResize, {
      passive: true
    });
    window.addEventListener('orientationchange', handleResize, {
      passive: true
    });
    callback();
    return function () {
      if (frame) cancelAnimationFrame(frame);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [callback]);
};

exports.useResize = useResize;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 6912:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.scrollToElement = exports.isElementVisibleInViewport = exports.isElementVisibleInContainer = exports.getFocusableElements = void 0;

var getFocusableElements = function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(container.querySelectorAll('input,select,textarea,a[href],button,[tabindex],audio[controls],video[controls],[contenteditable]:not([contenteditable="false"])')).filter(function (el) {
    return el.getAttribute('disabled') === null;
  }).filter(function (el) {
    return el.getAttribute('aria-disabled') !== 'true';
  }).filter(function (el) {
    var tabindex = el.getAttribute('tabindex');
    return tabindex === null || parseInt(tabindex, 10) >= 0;
  });
};

exports.getFocusableElements = getFocusableElements;

var scrollToElement = function scrollToElement(targetEl) {
  var rect = targetEl.getBoundingClientRect();
  var headerHeight = document.documentElement.style.getPropertyValue('--header-height');
  window.scrollTo({
    behavior: 'smooth',
    top: Math.max(0, window.pageYOffset + rect.y - parseInt(headerHeight, 10) - 16)
  });
  var id = targetEl.getAttribute('id');

  if (id) {
    history.pushState({}, '', "#".concat(id));
    window.dispatchEvent(new Event('hashchange'));
  }
};

exports.scrollToElement = scrollToElement;

var isElementVisibleInViewport = function isElementVisibleInViewport(e) {
  var _e$getBoundingClientR = e.getBoundingClientRect(),
      bottom = _e$getBoundingClientR.bottom,
      left = _e$getBoundingClientR.left,
      right = _e$getBoundingClientR.right,
      top = _e$getBoundingClientR.top;

  return top >= 0 && left >= 0 && bottom <= (window.innerHeight || document.documentElement.clientHeight) && right <= (window.innerWidth || document.documentElement.clientWidth);
}; // See: https://htmldom.dev/check-if-an-element-is-visible-in-a-scrollable-container/


exports.isElementVisibleInViewport = isElementVisibleInViewport;

var isElementVisibleInContainer = function isElementVisibleInContainer(e, container) {
  var visibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var _e$getBoundingClientR2 = e.getBoundingClientRect(),
      bottom = _e$getBoundingClientR2.bottom,
      height = _e$getBoundingClientR2.height,
      top = _e$getBoundingClientR2.top;

  var containerRect = container.getBoundingClientRect();
  var vis = Math.min(Math.max(visibility, 0), 1);
  var minVisibleHeight = height * vis;
  var visibleBottomEdge = Math.min(bottom, containerRect.bottom);
  var visibleTopEdge = Math.max(top, containerRect.top);
  var visibleHeight = visibleBottomEdge - visibleTopEdge;
  return visibleHeight >= minVisibleHeight;
};

exports.isElementVisibleInContainer = isElementVisibleInContainer;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 9930:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.w = void 0;
var inMemoryStorage = {};

function isSupported(getStorage) {
  try {
    var key = '__some_random_key_you_are_not_going_to_use__';
    getStorage().setItem(key, key);
    getStorage().removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}

var safeStorage = function safeStorage(getStorage) {
  return {
    clear: function clear() {
      if (isSupported(getStorage)) {
        getStorage().clear();
      } else {
        inMemoryStorage = {};
      }
    },
    getItem: function getItem(key) {
      var _inMemoryStorage;

      if (isSupported(getStorage)) {
        return getStorage().getItem(key);
      }

      return (_inMemoryStorage = inMemoryStorage) === null || _inMemoryStorage === void 0 ? void 0 : _inMemoryStorage[key];
    },
    removeItem: function removeItem(key) {
      if (isSupported(getStorage)) {
        getStorage().removeItem(key);
      } else {
        var _inMemoryStorage2;

        (_inMemoryStorage2 = inMemoryStorage) === null || _inMemoryStorage2 === void 0 ? true : delete _inMemoryStorage2[key];
      }
    },
    setItem: function setItem(key, value) {
      if (isSupported(getStorage)) {
        getStorage().setItem(key, value);
      } else {
        inMemoryStorage[key] = value;
      }
    }
  };
};

exports.w = safeStorage;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [401,3107,9874,4790,121,5830,3554,9774,2888,179], function() { return __webpack_exec__(4458), __webpack_exec__(6456); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);